(function() {
  var __webpack_modules__ = {
    88: function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {
      "use strict";
      var main_namespaceObject = {};
      __webpack_require__.r(main_namespaceObject);
      var injectStylesIntoStyleTag = __webpack_require__(596), injectStylesIntoStyleTag_default = __webpack_require__.n(injectStylesIntoStyleTag), styleDomAPI = __webpack_require__(139), styleDomAPI_default = __webpack_require__.n(styleDomAPI), insertBySelector = __webpack_require__(176), insertBySelector_default = __webpack_require__.n(insertBySelector), setAttributesWithoutAttributes = __webpack_require__(120), setAttributesWithoutAttributes_default = __webpack_require__.n(setAttributesWithoutAttributes), insertStyleElement = __webpack_require__(808), insertStyleElement_default = __webpack_require__.n(insertStyleElement), styleTagTransform = __webpack_require__(936), styleTagTransform_default = __webpack_require__.n(styleTagTransform), options = {};
      options.styleTagTransform = styleTagTransform_default(), options.setAttributes = setAttributesWithoutAttributes_default(), 
      options.insert = insertBySelector_default().bind(null, "head"), options.domAPI = styleDomAPI_default(), 
      options.insertStyleElement = insertStyleElement_default();
      injectStylesIntoStyleTag_default()(main_namespaceObject.default, options), main_namespaceObject.default && main_namespaceObject.default.locals && main_namespaceObject.default.locals;
    },
    596: function(module) {
      "use strict";
      var stylesInDOM = [];
      function getIndexByIdentifier(identifier) {
        for (var result = -1, i = 0; i < stylesInDOM.length; i++) if (stylesInDOM[i].identifier === identifier) {
          result = i;
          break;
        }
        return result;
      }
      function modulesToDom(list, options) {
        for (var idCountMap = {}, identifiers = [], i = 0; i < list.length; i++) {
          var item = list[i], id = options.base ? item[0] + options.base : item[0], count = idCountMap[id] || 0, identifier = "".concat(id, " ").concat(count);
          idCountMap[id] = count + 1;
          var indexByIdentifier = getIndexByIdentifier(identifier), obj = {
            css: item[1],
            media: item[2],
            sourceMap: item[3],
            supports: item[4],
            layer: item[5]
          };
          if (-1 !== indexByIdentifier) stylesInDOM[indexByIdentifier].references++, stylesInDOM[indexByIdentifier].updater(obj); else {
            var updater = addElementStyle(obj, options);
            options.byIndex = i, stylesInDOM.splice(i, 0, {
              identifier: identifier,
              updater: updater,
              references: 1
            });
          }
          identifiers.push(identifier);
        }
        return identifiers;
      }
      function addElementStyle(obj, options) {
        var api = options.domAPI(options);
        api.update(obj);
        return function(newObj) {
          if (newObj) {
            if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) return;
            api.update(obj = newObj);
          } else api.remove();
        };
      }
      module.exports = function(list, options) {
        var lastIdentifiers = modulesToDom(list = list || [], options = options || {});
        return function(newList) {
          newList = newList || [];
          for (var i = 0; i < lastIdentifiers.length; i++) {
            var index = getIndexByIdentifier(lastIdentifiers[i]);
            stylesInDOM[index].references--;
          }
          for (var newLastIdentifiers = modulesToDom(newList, options), _i = 0; _i < lastIdentifiers.length; _i++) {
            var _index = getIndexByIdentifier(lastIdentifiers[_i]);
            0 === stylesInDOM[_index].references && (stylesInDOM[_index].updater(), stylesInDOM.splice(_index, 1));
          }
          lastIdentifiers = newLastIdentifiers;
        };
      };
    },
    176: function(module) {
      "use strict";
      var memo = {};
      module.exports = function(insert, style) {
        var target = function(target) {
          if (void 0 === memo[target]) {
            var styleTarget = document.querySelector(target);
            if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) try {
              styleTarget = styleTarget.contentDocument.head;
            } catch (e) {
              styleTarget = null;
            }
            memo[target] = styleTarget;
          }
          return memo[target];
        }(insert);
        if (!target) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        target.appendChild(style);
      };
    },
    808: function(module) {
      "use strict";
      module.exports = function(options) {
        var element = document.createElement("style");
        return options.setAttributes(element, options.attributes), options.insert(element, options.options), 
        element;
      };
    },
    120: function(module, __unused_webpack_exports, __webpack_require__) {
      "use strict";
      module.exports = function(styleElement) {
        var nonce = __webpack_require__.nc;
        nonce && styleElement.setAttribute("nonce", nonce);
      };
    },
    139: function(module) {
      "use strict";
      module.exports = function(options) {
        if ("undefined" == typeof document) return {
          update: function() {},
          remove: function() {}
        };
        var styleElement = options.insertStyleElement(options);
        return {
          update: function(obj) {
            !function(styleElement, options, obj) {
              var css = "";
              obj.supports && (css += "@supports (".concat(obj.supports, ") {")), obj.media && (css += "@media ".concat(obj.media, " {"));
              var needLayer = void 0 !== obj.layer;
              needLayer && (css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {")), 
              css += obj.css, needLayer && (css += "}"), obj.media && (css += "}"), obj.supports && (css += "}");
              var sourceMap = obj.sourceMap;
              sourceMap && "undefined" != typeof btoa && (css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */")), 
              options.styleTagTransform(css, styleElement, options.options);
            }(styleElement, options, obj);
          },
          remove: function() {
            !function(styleElement) {
              if (null === styleElement.parentNode) return !1;
              styleElement.parentNode.removeChild(styleElement);
            }(styleElement);
          }
        };
      };
    },
    936: function(module) {
      "use strict";
      module.exports = function(css, styleElement) {
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
          for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
          styleElement.appendChild(document.createTextNode(css));
        }
      };
    },
    864: function(module, __unused_webpack_exports, __webpack_require__) {
      var f;
      f = function() {
        var define, module, exports;
        return function e(t, n, r) {
          function s(o, u) {
            if (!n[o]) {
              if (!t[o]) {
                if (i) return i(o, !0);
                var f = new Error("Cannot find module '" + o + "'");
                throw f.code = "MODULE_NOT_FOUND", f;
              }
              var l = n[o] = {
                exports: {}
              };
              t[o][0].call(l.exports, (function(e) {
                var n = t[o][1][e];
                return s(n || e);
              }), l, l.exports, e, t, n, r);
            }
            return n[o].exports;
          }
          for (var i = void 0, o = 0; o < r.length; o++) s(r[o]);
          return s;
        }({
          1: [ function(require, module, exports) {
            var root, factory;
            root = this, factory = function() {
              var CryptoJS = CryptoJS || function(Math, undefined) {
                var create = Object.create || function() {
                  function F() {}
                  return function(obj) {
                    var subtype;
                    return F.prototype = obj, subtype = new F, F.prototype = null, subtype;
                  };
                }(), C = {}, C_lib = C.lib = {}, Base = C_lib.Base = {
                  extend: function(overrides) {
                    var subtype = create(this);
                    return overrides && subtype.mixIn(overrides), subtype.hasOwnProperty("init") && this.init !== subtype.init || (subtype.init = function() {
                      subtype.$super.init.apply(this, arguments);
                    }), subtype.init.prototype = subtype, subtype.$super = this, subtype;
                  },
                  create: function() {
                    var instance = this.extend();
                    return instance.init.apply(instance, arguments), instance;
                  },
                  init: function() {},
                  mixIn: function(properties) {
                    for (var propertyName in properties) properties.hasOwnProperty(propertyName) && (this[propertyName] = properties[propertyName]);
                    properties.hasOwnProperty("toString") && (this.toString = properties.toString);
                  },
                  clone: function() {
                    return this.init.prototype.extend(this);
                  }
                }, WordArray = C_lib.WordArray = Base.extend({
                  init: function(words, sigBytes) {
                    words = this.words = words || [], this.sigBytes = null != sigBytes ? sigBytes : 4 * words.length;
                  },
                  toString: function(encoder) {
                    return (encoder || Hex).stringify(this);
                  },
                  concat: function(wordArray) {
                    var thisWords = this.words, thatWords = wordArray.words, thisSigBytes = this.sigBytes, thatSigBytes = wordArray.sigBytes;
                    if (this.clamp(), thisSigBytes % 4) for (var i = 0; thatSigBytes > i; i++) {
                      var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                      thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                    } else for (i = 0; thatSigBytes > i; i += 4) thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                    return this.sigBytes += thatSigBytes, this;
                  },
                  clamp: function() {
                    var words = this.words, sigBytes = this.sigBytes;
                    words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8, words.length = Math.ceil(sigBytes / 4);
                  },
                  clone: function() {
                    var clone = Base.clone.call(this);
                    return clone.words = this.words.slice(0), clone;
                  },
                  random: function(nBytes) {
                    for (var rcache, words = [], r = function(m_w) {
                      var m_z = 987654321, mask = 4294967295;
                      return function() {
                        var result = ((m_z = 36969 * (65535 & m_z) + (m_z >> 16) & mask) << 16) + (m_w = 18e3 * (65535 & m_w) + (m_w >> 16) & mask) & mask;
                        return result /= 4294967296, (result += .5) * (Math.random() > .5 ? 1 : -1);
                      };
                    }, i = 0; nBytes > i; i += 4) {
                      var _r = r(4294967296 * (rcache || Math.random()));
                      rcache = 987654071 * _r(), words.push(4294967296 * _r() | 0);
                    }
                    return new WordArray.init(words, nBytes);
                  }
                }), C_enc = C.enc = {}, Hex = C_enc.Hex = {
                  stringify: function(wordArray) {
                    for (var words = wordArray.words, sigBytes = wordArray.sigBytes, hexChars = [], i = 0; sigBytes > i; i++) {
                      var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                      hexChars.push((bite >>> 4).toString(16)), hexChars.push((15 & bite).toString(16));
                    }
                    return hexChars.join("");
                  },
                  parse: function(hexStr) {
                    for (var hexStrLength = hexStr.length, words = [], i = 0; hexStrLength > i; i += 2) words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                    return new WordArray.init(words, hexStrLength / 2);
                  }
                }, Latin1 = C_enc.Latin1 = {
                  stringify: function(wordArray) {
                    for (var words = wordArray.words, sigBytes = wordArray.sigBytes, latin1Chars = [], i = 0; sigBytes > i; i++) {
                      var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                      latin1Chars.push(String.fromCharCode(bite));
                    }
                    return latin1Chars.join("");
                  },
                  parse: function(latin1Str) {
                    for (var latin1StrLength = latin1Str.length, words = [], i = 0; latin1StrLength > i; i++) words[i >>> 2] |= (255 & latin1Str.charCodeAt(i)) << 24 - i % 4 * 8;
                    return new WordArray.init(words, latin1StrLength);
                  }
                }, Utf8 = C_enc.Utf8 = {
                  stringify: function(wordArray) {
                    try {
                      return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                    } catch (e) {
                      throw new Error("Malformed UTF-8 data");
                    }
                  },
                  parse: function(utf8Str) {
                    return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
                  }
                }, BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
                  reset: function() {
                    this._data = new WordArray.init, this._nDataBytes = 0;
                  },
                  _append: function(data) {
                    "string" == typeof data && (data = Utf8.parse(data)), this._data.concat(data), this._nDataBytes += data.sigBytes;
                  },
                  _process: function(doFlush) {
                    var data = this._data, dataWords = data.words, dataSigBytes = data.sigBytes, blockSize = this.blockSize, nBlocksReady = dataSigBytes / (4 * blockSize), nWordsReady = (nBlocksReady = doFlush ? Math.ceil(nBlocksReady) : Math.max((0 | nBlocksReady) - this._minBufferSize, 0)) * blockSize, nBytesReady = Math.min(4 * nWordsReady, dataSigBytes);
                    if (nWordsReady) {
                      for (var offset = 0; nWordsReady > offset; offset += blockSize) this._doProcessBlock(dataWords, offset);
                      var processedWords = dataWords.splice(0, nWordsReady);
                      data.sigBytes -= nBytesReady;
                    }
                    return new WordArray.init(processedWords, nBytesReady);
                  },
                  clone: function() {
                    var clone = Base.clone.call(this);
                    return clone._data = this._data.clone(), clone;
                  },
                  _minBufferSize: 0
                }), C_algo = (C_lib.Hasher = BufferedBlockAlgorithm.extend({
                  cfg: Base.extend(),
                  init: function(cfg) {
                    this.cfg = this.cfg.extend(cfg), this.reset();
                  },
                  reset: function() {
                    BufferedBlockAlgorithm.reset.call(this), this._doReset();
                  },
                  update: function(messageUpdate) {
                    return this._append(messageUpdate), this._process(), this;
                  },
                  finalize: function(messageUpdate) {
                    return messageUpdate && this._append(messageUpdate), this._doFinalize();
                  },
                  blockSize: 16,
                  _createHelper: function(hasher) {
                    return function(message, cfg) {
                      return new hasher.init(cfg).finalize(message);
                    };
                  },
                  _createHmacHelper: function(hasher) {
                    return function(message, key) {
                      return new C_algo.HMAC.init(hasher, key).finalize(message);
                    };
                  }
                }), C.algo = {});
                return C;
              }(Math);
              return CryptoJS;
            }, "object" == typeof exports ? module.exports = exports = factory() : "function" == typeof define && define.amd ? define([], factory) : root.CryptoJS = factory();
          }, {} ],
          2: [ function(require, module, exports) {
            var root, factory;
            root = this, factory = function(CryptoJS) {
              return C_lib = (C = CryptoJS).lib, WordArray = C_lib.WordArray, Hasher = C_lib.Hasher, 
              C_algo = C.algo, W = [], SHA1 = C_algo.SHA1 = Hasher.extend({
                _doReset: function() {
                  this._hash = new WordArray.init([ 1732584193, 4023233417, 2562383102, 271733878, 3285377520 ]);
                },
                _doProcessBlock: function(M, offset) {
                  for (var H = this._hash.words, a = H[0], b = H[1], c = H[2], d = H[3], e = H[4], i = 0; 80 > i; i++) {
                    if (16 > i) W[i] = 0 | M[offset + i]; else {
                      var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                      W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    t += 20 > i ? 1518500249 + (b & c | ~b & d) : 40 > i ? 1859775393 + (b ^ c ^ d) : 60 > i ? (b & c | b & d | c & d) - 1894007588 : (b ^ c ^ d) - 899497514, 
                    e = d, d = c, c = b << 30 | b >>> 2, b = a, a = t;
                  }
                  H[0] = H[0] + a | 0, H[1] = H[1] + b | 0, H[2] = H[2] + c | 0, H[3] = H[3] + d | 0, 
                  H[4] = H[4] + e | 0;
                },
                _doFinalize: function() {
                  var data = this._data, dataWords = data.words, nBitsTotal = 8 * this._nDataBytes, nBitsLeft = 8 * data.sigBytes;
                  return dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32, dataWords[14 + (nBitsLeft + 64 >>> 9 << 4)] = Math.floor(nBitsTotal / 4294967296), 
                  dataWords[15 + (nBitsLeft + 64 >>> 9 << 4)] = nBitsTotal, data.sigBytes = 4 * dataWords.length, 
                  this._process(), this._hash;
                },
                clone: function() {
                  var clone = Hasher.clone.call(this);
                  return clone._hash = this._hash.clone(), clone;
                }
              }), C.SHA1 = Hasher._createHelper(SHA1), C.HmacSHA1 = Hasher._createHmacHelper(SHA1), 
              CryptoJS.SHA1;
              var C, C_lib, WordArray, Hasher, C_algo, W, SHA1;
            }, "object" == typeof exports ? module.exports = exports = factory(require("./core")) : "function" == typeof define && define.amd ? define([ "./core" ], factory) : factory(root.CryptoJS);
          }, {
            "./core": 1
          } ],
          3: [ function(require, module, exports) {
            (function() {
              function unparse(buf, offset) {
                var i = offset || 0, bth = _byteToHex;
                return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
              }
              function v4(options, buf, offset) {
                var i = buf && offset || 0;
                "string" == typeof options && (buf = "binary" == options ? new BufferClass(16) : null, 
                options = null);
                var rnds = (options = options || {}).random || (options.rng || _rng)();
                if (rnds[6] = 15 & rnds[6] | 64, rnds[8] = 63 & rnds[8] | 128, buf) for (var ii = 0; 16 > ii; ii++) buf[i + ii] = rnds[ii];
                return buf || unparse(rnds);
              }
              var _rng, _global = this;
              if ("function" == typeof _global.require) try {
                var _rb = _global.require("crypto").randomBytes;
                _rng = _rb && function() {
                  return _rb(16);
                };
              } catch (e) {}
              if (!_rng && _global.crypto && crypto.getRandomValues) {
                var _rnds8 = new Uint8Array(16);
                _rng = function() {
                  return crypto.getRandomValues(_rnds8), _rnds8;
                };
              }
              if (!_rng) {
                var _rnds = new Array(16);
                _rng = function() {
                  for (var r, i = 0; 16 > i; i++) 0 == (3 & i) && (r = 4294967296 * Math.random()), 
                  _rnds[i] = r >>> ((3 & i) << 3) & 255;
                  return _rnds;
                };
              }
              for (var BufferClass = "function" == typeof _global.Buffer ? _global.Buffer : Array, _byteToHex = [], _hexToByte = {}, i = 0; 256 > i; i++) _byteToHex[i] = (i + 256).toString(16).substr(1), 
              _hexToByte[_byteToHex[i]] = i;
              var _seedBytes = _rng(), _nodeId = [ 1 | _seedBytes[0], _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5] ], _clockseq = 16383 & (_seedBytes[6] << 8 | _seedBytes[7]), _lastMSecs = 0, _lastNSecs = 0, uuid = v4;
              if (uuid.v1 = function(options, buf, offset) {
                var i = buf && offset || 0, b = buf || [], clockseq = null != (options = options || {}).clockseq ? options.clockseq : _clockseq, msecs = null != options.msecs ? options.msecs : (new Date).getTime(), nsecs = null != options.nsecs ? options.nsecs : _lastNSecs + 1, dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
                if (0 > dt && null == options.clockseq && (clockseq = clockseq + 1 & 16383), (0 > dt || msecs > _lastMSecs) && null == options.nsecs && (nsecs = 0), 
                nsecs >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                _lastMSecs = msecs, _lastNSecs = nsecs, _clockseq = clockseq;
                var tl = (1e4 * (268435455 & (msecs += 122192928e5)) + nsecs) % 4294967296;
                b[i++] = tl >>> 24 & 255, b[i++] = tl >>> 16 & 255, b[i++] = tl >>> 8 & 255, b[i++] = 255 & tl;
                var tmh = msecs / 4294967296 * 1e4 & 268435455;
                b[i++] = tmh >>> 8 & 255, b[i++] = 255 & tmh, b[i++] = tmh >>> 24 & 15 | 16, b[i++] = tmh >>> 16 & 255, 
                b[i++] = clockseq >>> 8 | 128, b[i++] = 255 & clockseq;
                for (var node = options.node || _nodeId, n = 0; 6 > n; n++) b[i + n] = node[n];
                return buf || unparse(b);
              }, uuid.v4 = v4, uuid.parse = function(s, buf, offset) {
                var i = buf && offset || 0, ii = 0;
                for (buf = buf || [], s.toLowerCase().replace(/[0-9a-f]{2}/g, (function(oct) {
                  16 > ii && (buf[i + ii++] = _hexToByte[oct]);
                })); 16 > ii; ) buf[i + ii++] = 0;
                return buf;
              }, uuid.unparse = unparse, uuid.BufferClass = BufferClass, "function" == typeof define && define.amd) define((function() {
                return uuid;
              })); else if (void 0 !== module && module.exports) module.exports = uuid; else {
                var _previousRoot = _global.uuid;
                uuid.noConflict = function() {
                  return _global.uuid = _previousRoot, uuid;
                }, _global.uuid = uuid;
              }
            }).call(this);
          }, {} ],
          4: [ function(require, module, exports) {
            var engine = require("../src/store-engine"), storages = require("../storages/all"), plugins = [ require("../plugins/json2") ];
            module.exports = engine.createStore(storages, plugins);
          }, {
            "../plugins/json2": 5,
            "../src/store-engine": 7,
            "../storages/all": 9
          } ],
          5: [ function(require, module, exports) {
            module.exports = function() {
              return require("./lib/json2"), {};
            };
          }, {
            "./lib/json2": 6
          } ],
          6: [ function(require, module, exports) {
            "object" != typeof JSON && (JSON = {}), function() {
              "use strict";
              function f(n) {
                return 10 > n ? "0" + n : n;
              }
              function this_value() {
                return this.valueOf();
              }
              function quote(string) {
                return rx_escapable.lastIndex = 0, rx_escapable.test(string) ? '"' + string.replace(rx_escapable, (function(a) {
                  var c = meta[a];
                  return "string" == typeof c ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                })) + '"' : '"' + string + '"';
              }
              function str(key, holder) {
                var i, k, v, length, partial, mind = gap, value = holder[key];
                switch (value && "object" == typeof value && "function" == typeof value.toJSON && (value = value.toJSON(key)), 
                "function" == typeof rep && (value = rep.call(holder, key, value)), typeof value) {
                 case "string":
                  return quote(value);

                 case "number":
                  return isFinite(value) ? String(value) : "null";

                 case "boolean":
                 case "null":
                  return String(value);

                 case "object":
                  if (!value) return "null";
                  if (gap += indent, partial = [], "[object Array]" === Object.prototype.toString.apply(value)) {
                    for (length = value.length, i = 0; length > i; i += 1) partial[i] = str(i, value) || "null";
                    return v = 0 === partial.length ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]", 
                    gap = mind, v;
                  }
                  if (rep && "object" == typeof rep) for (length = rep.length, i = 0; length > i; i += 1) "string" == typeof rep[i] && (v = str(k = rep[i], value)) && partial.push(quote(k) + (gap ? ": " : ":") + v); else for (k in value) Object.prototype.hasOwnProperty.call(value, k) && (v = str(k, value)) && partial.push(quote(k) + (gap ? ": " : ":") + v);
                  return v = 0 === partial.length ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}", 
                  gap = mind, v;
                }
              }
              var rx_one = /^[\],:{}\s]*$/, rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, rx_four = /(?:^|:|,)(?:\s*\[)+/g, rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, gap, indent, meta, rep;
              "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function() {
                return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
              }, Boolean.prototype.toJSON = this_value, Number.prototype.toJSON = this_value, 
              String.prototype.toJSON = this_value), "function" != typeof JSON.stringify && (meta = {
                "\b": "\\b",
                "\t": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
              }, JSON.stringify = function(value, replacer, space) {
                var i;
                if (gap = "", indent = "", "number" == typeof space) for (i = 0; space > i; i += 1) indent += " "; else "string" == typeof space && (indent = space);
                if (rep = replacer, replacer && "function" != typeof replacer && ("object" != typeof replacer || "number" != typeof replacer.length)) throw new Error("JSON.stringify");
                return str("", {
                  "": value
                });
              }), "function" != typeof JSON.parse && (JSON.parse = function(text, reviver) {
                function walk(holder, key) {
                  var k, v, value = holder[key];
                  if (value && "object" == typeof value) for (k in value) Object.prototype.hasOwnProperty.call(value, k) && (void 0 !== (v = walk(value, k)) ? value[k] = v : delete value[k]);
                  return reviver.call(holder, key, value);
                }
                var j;
                if (text = String(text), rx_dangerous.lastIndex = 0, rx_dangerous.test(text) && (text = text.replace(rx_dangerous, (function(a) {
                  return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                }))), rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) return j = eval("(" + text + ")"), 
                "function" == typeof reviver ? walk({
                  "": j
                }, "") : j;
                throw new SyntaxError("JSON.parse");
              });
            }();
          }, {} ],
          7: [ function(require, module, exports) {
            function createStore(storages, plugins, namespace) {
              namespace || (namespace = ""), storages && !isList(storages) && (storages = [ storages ]), 
              plugins && !isList(plugins) && (plugins = [ plugins ]);
              var namespacePrefix = namespace ? "__storejs_" + namespace + "_" : "", namespaceRegexp = namespace ? new RegExp("^" + namespacePrefix) : null;
              if (!/^[a-zA-Z0-9_\-]*$/.test(namespace)) throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
              var _privateStoreProps = {
                _namespacePrefix: namespacePrefix,
                _namespaceRegexp: namespaceRegexp,
                _testStorage: function(storage) {
                  try {
                    var testStr = "__storejs__test__";
                    storage.write(testStr, testStr);
                    var ok = storage.read(testStr) === testStr;
                    return storage.remove(testStr), ok;
                  } catch (e) {
                    return !1;
                  }
                },
                _assignPluginFnProp: function(pluginFnProp, propName) {
                  var oldFn = this[propName];
                  this[propName] = function() {
                    var args = slice(arguments, 0), self = this, newFnArgs = [ function() {
                      return oldFn ? (each(arguments, (function(arg, i) {
                        args[i] = arg;
                      })), oldFn.apply(self, args)) : void 0;
                    } ].concat(args);
                    return pluginFnProp.apply(self, newFnArgs);
                  };
                },
                _serialize: function(obj) {
                  return JSON.stringify(obj);
                },
                _deserialize: function(strVal, defaultVal) {
                  if (!strVal) return defaultVal;
                  var val = "";
                  try {
                    val = JSON.parse(strVal);
                  } catch (e) {
                    val = strVal;
                  }
                  return void 0 !== val ? val : defaultVal;
                },
                _addStorage: function(storage) {
                  this.enabled || this._testStorage(storage) && (this.storage = storage, this.enabled = !0);
                },
                _addPlugin: function(plugin) {
                  var self = this;
                  if (isList(plugin)) each(plugin, (function(plugin) {
                    self._addPlugin(plugin);
                  })); else if (!pluck(this.plugins, (function(seenPlugin) {
                    return plugin === seenPlugin;
                  }))) {
                    if (this.plugins.push(plugin), !isFunction(plugin)) throw new Error("Plugins must be function values that return objects");
                    var pluginProperties = plugin.call(this);
                    if (!isObject(pluginProperties)) throw new Error("Plugins must return an object of function properties");
                    each(pluginProperties, (function(pluginFnProp, propName) {
                      if (!isFunction(pluginFnProp)) throw new Error("Bad plugin property: " + propName + " from plugin " + plugin.name + ". Plugins should only return functions.");
                      self._assignPluginFnProp(pluginFnProp, propName);
                    }));
                  }
                },
                addStorage: function(storage) {
                  (function() {
                    var _console = "undefined" == typeof console ? null : console;
                    _console && (_console.warn ? _console.warn : _console.log).apply(_console, arguments);
                  })("store.addStorage(storage) is deprecated. Use createStore([storages])"), this._addStorage(storage);
                }
              }, store = create(_privateStoreProps, storeAPI, {
                plugins: []
              });
              return store.raw = {}, each(store, (function(prop, propName) {
                isFunction(prop) && (store.raw[propName] = bind(store, prop));
              })), each(storages, (function(storage) {
                store._addStorage(storage);
              })), each(plugins, (function(plugin) {
                store._addPlugin(plugin);
              })), store;
            }
            var util = require("./util"), slice = util.slice, pluck = util.pluck, each = util.each, bind = util.bind, create = util.create, isList = util.isList, isFunction = util.isFunction, isObject = util.isObject;
            module.exports = {
              createStore: createStore
            };
            var storeAPI = {
              version: "2.0.12",
              enabled: !1,
              get: function(key, optionalDefaultValue) {
                var data = this.storage.read(this._namespacePrefix + key);
                return this._deserialize(data, optionalDefaultValue);
              },
              set: function(key, value) {
                return void 0 === value ? this.remove(key) : (this.storage.write(this._namespacePrefix + key, this._serialize(value)), 
                value);
              },
              remove: function(key) {
                this.storage.remove(this._namespacePrefix + key);
              },
              each: function(callback) {
                var self = this;
                this.storage.each((function(val, namespacedKey) {
                  callback.call(self, self._deserialize(val), (namespacedKey || "").replace(self._namespaceRegexp, ""));
                }));
              },
              clearAll: function() {
                this.storage.clearAll();
              },
              hasNamespace: function(namespace) {
                return this._namespacePrefix == "__storejs_" + namespace + "_";
              },
              createStore: function() {
                return createStore.apply(this, arguments);
              },
              addPlugin: function(plugin) {
                this._addPlugin(plugin);
              },
              namespace: function(namespace) {
                return createStore(this.storage, this.plugins, namespace);
              }
            };
          }, {
            "./util": 8
          } ],
          8: [ function(require, module, exports) {
            (function(global) {
              function slice(arr, index) {
                return Array.prototype.slice.call(arr, index || 0);
              }
              function each(obj, fn) {
                pluck(obj, (function(val, key) {
                  return fn(val, key), !1;
                }));
              }
              function pluck(obj, fn) {
                if (isList(obj)) {
                  for (var i = 0; i < obj.length; i++) if (fn(obj[i], i)) return obj[i];
                } else for (var key in obj) if (obj.hasOwnProperty(key) && fn(obj[key], key)) return obj[key];
              }
              function isList(val) {
                return null != val && "function" != typeof val && "number" == typeof val.length;
              }
              var assign = Object.assign ? Object.assign : function(obj, props1, props2, etc) {
                for (var i = 1; i < arguments.length; i++) each(Object(arguments[i]), (function(val, key) {
                  obj[key] = val;
                }));
                return obj;
              }, create = function() {
                function F() {}
                return Object.create ? function(obj, assignProps1, assignProps2, etc) {
                  var assignArgsList = slice(arguments, 1);
                  return assign.apply(this, [ Object.create(obj) ].concat(assignArgsList));
                } : function(obj, assignProps1, assignProps2, etc) {
                  var assignArgsList = slice(arguments, 1);
                  return F.prototype = obj, assign.apply(this, [ new F ].concat(assignArgsList));
                };
              }(), trim = String.prototype.trim ? function(str) {
                return String.prototype.trim.call(str);
              } : function(str) {
                return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
              }, Global = "undefined" != typeof window ? window : global;
              module.exports = {
                assign: assign,
                create: create,
                trim: trim,
                bind: function(obj, fn) {
                  return function() {
                    return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
                  };
                },
                slice: slice,
                each: each,
                map: function(obj, fn) {
                  var res = isList(obj) ? [] : {};
                  return pluck(obj, (function(v, k) {
                    return res[k] = fn(v, k), !1;
                  })), res;
                },
                pluck: pluck,
                isList: isList,
                isFunction: function(val) {
                  return val && "[object Function]" === {}.toString.call(val);
                },
                isObject: function(val) {
                  return val && "[object Object]" === {}.toString.call(val);
                },
                Global: Global
              };
            }).call(this, void 0 !== __webpack_require__.g ? __webpack_require__.g : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {} ],
          9: [ function(require, module, exports) {
            module.exports = [ require("./localStorage"), require("./oldFF-globalStorage"), require("./oldIE-userDataStorage"), require("./cookieStorage"), require("./sessionStorage"), require("./memoryStorage") ];
          }, {
            "./cookieStorage": 10,
            "./localStorage": 11,
            "./memoryStorage": 12,
            "./oldFF-globalStorage": 13,
            "./oldIE-userDataStorage": 14,
            "./sessionStorage": 15
          } ],
          10: [ function(require, module, exports) {
            function each(callback) {
              for (var cookies = doc.cookie.split(/; ?/g), i = cookies.length - 1; i >= 0; i--) if (trim(cookies[i])) {
                var kvp = cookies[i].split("="), key = unescape(kvp[0]);
                callback(unescape(kvp[1]), key);
              }
            }
            function remove(key) {
              key && _has(key) && (doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
            }
            function _has(key) {
              return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(doc.cookie);
            }
            var util = require("../src/util"), Global = util.Global, trim = util.trim;
            module.exports = {
              name: "cookieStorage",
              read: function(key) {
                if (!key || !_has(key)) return null;
                var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
                return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"));
              },
              write: function(key, data) {
                key && (doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/");
              },
              each: each,
              remove: remove,
              clearAll: function() {
                each((function(_, key) {
                  remove(key);
                }));
              }
            };
            var doc = Global.document;
          }, {
            "../src/util": 8
          } ],
          11: [ function(require, module, exports) {
            function localStorage() {
              return Global.localStorage;
            }
            function read(key) {
              return localStorage().getItem(key);
            }
            var Global = require("../src/util").Global;
            module.exports = {
              name: "localStorage",
              read: read,
              write: function(key, data) {
                return localStorage().setItem(key, data);
              },
              each: function(fn) {
                for (var i = localStorage().length - 1; i >= 0; i--) {
                  var key = localStorage().key(i);
                  fn(read(key), key);
                }
              },
              remove: function(key) {
                return localStorage().removeItem(key);
              },
              clearAll: function() {
                return localStorage().clear();
              }
            };
          }, {
            "../src/util": 8
          } ],
          12: [ function(require, module, exports) {
            module.exports = {
              name: "memoryStorage",
              read: function(key) {
                return memoryStorage[key];
              },
              write: function(key, data) {
                memoryStorage[key] = data;
              },
              each: function(callback) {
                for (var key in memoryStorage) memoryStorage.hasOwnProperty(key) && callback(memoryStorage[key], key);
              },
              remove: function(key) {
                delete memoryStorage[key];
              },
              clearAll: function(key) {
                memoryStorage = {};
              }
            };
            var memoryStorage = {};
          }, {} ],
          13: [ function(require, module, exports) {
            function each(fn) {
              for (var i = globalStorage.length - 1; i >= 0; i--) {
                var key = globalStorage.key(i);
                fn(globalStorage[key], key);
              }
            }
            var Global = require("../src/util").Global;
            module.exports = {
              name: "oldFF-globalStorage",
              read: function(key) {
                return globalStorage[key];
              },
              write: function(key, data) {
                globalStorage[key] = data;
              },
              each: each,
              remove: function(key) {
                return globalStorage.removeItem(key);
              },
              clearAll: function() {
                each((function(key, _) {
                  delete globalStorage[key];
                }));
              }
            };
            var globalStorage = Global.globalStorage;
          }, {
            "../src/util": 8
          } ],
          14: [ function(require, module, exports) {
            function fixKey(key) {
              return key.replace(/^\d/, "___$&").replace(forbiddenCharsRegex, "___");
            }
            var Global = require("../src/util").Global;
            module.exports = {
              name: "oldIE-userDataStorage",
              write: function(unfixedKey, data) {
                if (!disable) {
                  var fixedKey = fixKey(unfixedKey);
                  _withStorageEl((function(storageEl) {
                    storageEl.setAttribute(fixedKey, data), storageEl.save(storageName);
                  }));
                }
              },
              read: function(unfixedKey) {
                if (!disable) {
                  var fixedKey = fixKey(unfixedKey), res = null;
                  return _withStorageEl((function(storageEl) {
                    res = storageEl.getAttribute(fixedKey);
                  })), res;
                }
              },
              each: function(callback) {
                _withStorageEl((function(storageEl) {
                  for (var attributes = storageEl.XMLDocument.documentElement.attributes, i = attributes.length - 1; i >= 0; i--) {
                    var attr = attributes[i];
                    callback(storageEl.getAttribute(attr.name), attr.name);
                  }
                }));
              },
              remove: function(unfixedKey) {
                var fixedKey = fixKey(unfixedKey);
                _withStorageEl((function(storageEl) {
                  storageEl.removeAttribute(fixedKey), storageEl.save(storageName);
                }));
              },
              clearAll: function() {
                _withStorageEl((function(storageEl) {
                  var attributes = storageEl.XMLDocument.documentElement.attributes;
                  storageEl.load(storageName);
                  for (var i = attributes.length - 1; i >= 0; i--) storageEl.removeAttribute(attributes[i].name);
                  storageEl.save(storageName);
                }));
              }
            };
            var storageName = "storejs", doc = Global.document, _withStorageEl = function() {
              if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) return null;
              var storageOwner, storageContainer, storageEl;
              try {
                (storageContainer = new ActiveXObject("htmlfile")).open(), storageContainer.write('<script>document.w=window<\/script><iframe src="/favicon.ico"></iframe>'), 
                storageContainer.close(), storageOwner = storageContainer.w.frames[0].document, 
                storageEl = storageOwner.createElement("div");
              } catch (e) {
                storageEl = doc.createElement("div"), storageOwner = doc.body;
              }
              return function(storeFunction) {
                var args = [].slice.call(arguments, 0);
                args.unshift(storageEl), storageOwner.appendChild(storageEl), storageEl.addBehavior("#default#userData"), 
                storageEl.load(storageName), storeFunction.apply(this, args), storageOwner.removeChild(storageEl);
              };
            }(), disable = (Global.navigator ? Global.navigator.userAgent : "").match(/ (MSIE 8|MSIE 9|MSIE 10)\./), forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
          }, {
            "../src/util": 8
          } ],
          15: [ function(require, module, exports) {
            function sessionStorage() {
              return Global.sessionStorage;
            }
            function read(key) {
              return sessionStorage().getItem(key);
            }
            var Global = require("../src/util").Global;
            module.exports = {
              name: "sessionStorage",
              read: read,
              write: function(key, data) {
                return sessionStorage().setItem(key, data);
              },
              each: function(fn) {
                for (var i = sessionStorage().length - 1; i >= 0; i--) {
                  var key = sessionStorage().key(i);
                  fn(read(key), key);
                }
              },
              remove: function(key) {
                return sessionStorage().removeItem(key);
              },
              clearAll: function() {
                return sessionStorage().clear();
              }
            };
          }, {
            "../src/util": 8
          } ],
          16: [ function(require, module, exports) {
            var Adapters, Storage, utils, bind = function(fn, me) {
              return function() {
                return fn.apply(me, arguments);
              };
            };
            utils = require("./utils"), Storage = require("./storage"), Adapters = function() {
              function Adapters() {}
              return Adapters.GimelAdapter = function() {
                function GimelAdapter(url, namespace, storage) {
                  null == storage && (storage = Adapters.LocalStorageAdapter), this.goal_complete = bind(this.goal_complete, this), 
                  this.experiment_start = bind(this.experiment_start, this), this._storage = storage, 
                  this.url = url, this.namespace = namespace, this._queue = JSON.parse(this._storage.get(this.queue_name) || "[]"), 
                  this._flush();
                }
                return GimelAdapter.prototype.queue_name = "_gimel_queue", GimelAdapter.prototype._remove_quuid = function(quuid) {
                  return _this = this, function(err, res) {
                    return err ? void 0 : (utils.remove(_this._queue, (function(el) {
                      return el.properties._quuid === quuid;
                    })), _this._storage.set(_this.queue_name, JSON.stringify(_this._queue)));
                  };
                  var _this;
                }, GimelAdapter.prototype._jquery_get = function(url, data, callback) {
                  return utils.log("send request using jQuery"), window.jQuery.ajax({
                    method: "GET",
                    url: url,
                    data: data,
                    success: callback
                  });
                }, GimelAdapter.prototype._plain_js_get = function(url, data, callback) {
                  var k, params, v, xhr;
                  return utils.log("fallback on plain js xhr"), xhr = new XMLHttpRequest, params = (params = function() {
                    var results;
                    for (k in results = [], data) v = data[k], results.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
                    return results;
                  }()).join("&").replace(/%20/g, "+"), xhr.open("GET", url + "?" + params), xhr.onload = function() {
                    return 200 === xhr.status ? callback() : void 0;
                  }, xhr.send();
                }, GimelAdapter.prototype._ajax_get = function(url, data, callback) {
                  var ref;
                  return (null != (ref = window.jQuery) ? ref.ajax : void 0) ? this._jquery_get(url, data, callback) : this._plain_js_get(url, data, callback);
                }, GimelAdapter.prototype._flush = function() {
                  var callback, i, item, len, ref, results;
                  for (results = [], i = 0, len = (ref = this._queue).length; len > i; i++) item = ref[i], 
                  callback = this._remove_quuid(item.properties._quuid), this._ajax_get(this.url, utils.omit(item.properties, "_quuid"), callback), 
                  results.push(null);
                  return results;
                }, GimelAdapter.prototype._user_uuid = function(experiment, goal) {
                  return experiment.user_id && goal.unique ? utils.sha1(this.namespace + "." + experiment.name + "." + experiment.user_id) : utils.uuid();
                }, GimelAdapter.prototype._track = function(experiment, variant, goal) {
                  return utils.log("Persistent Queue Gimel track: " + this.namespace + ", " + experiment.name + ", " + variant + ", " + goal.name), 
                  this._queue.length > 100 && this._queue.shift(), this._queue.push({
                    properties: {
                      experiment: experiment.name,
                      _quuid: utils.uuid(),
                      uuid: this._user_uuid(experiment, goal),
                      variant: variant,
                      event: goal.name,
                      namespace: this.namespace
                    }
                  }), this._storage.set(this.queue_name, JSON.stringify(this._queue)), this._flush();
                }, GimelAdapter.prototype.experiment_start = function(experiment, variant) {
                  return this._track(experiment, variant, {
                    name: "participate",
                    unique: !0
                  });
                }, GimelAdapter.prototype.goal_complete = function(experiment, variant, goal_name, props) {
                  return this._track(experiment, variant, utils.defaults({
                    name: goal_name
                  }, props));
                }, GimelAdapter;
              }(), Adapters.PersistentQueueGoogleAnalyticsAdapter = function() {
                function PersistentQueueGoogleAnalyticsAdapter(storage) {
                  null == storage && (storage = Adapters.LocalStorageAdapter), this.goal_complete = bind(this.goal_complete, this), 
                  this.experiment_start = bind(this.experiment_start, this), this._storage = storage, 
                  this._queue = JSON.parse(this._storage.get(this.queue_name) || "[]"), this._flush();
                }
                return PersistentQueueGoogleAnalyticsAdapter.prototype.namespace = "alephbet", PersistentQueueGoogleAnalyticsAdapter.prototype.queue_name = "_ga_queue", 
                PersistentQueueGoogleAnalyticsAdapter.prototype._remove_uuid = function(uuid) {
                  return _this = this, function() {
                    return utils.remove(_this._queue, (function(el) {
                      return el.uuid === uuid;
                    })), _this._storage.set(_this.queue_name, JSON.stringify(_this._queue));
                  };
                  var _this;
                }, PersistentQueueGoogleAnalyticsAdapter.prototype._flush = function() {
                  var callback, i, item, len, ref, results;
                  if ("function" != typeof ga) throw new Error("ga not defined. Please make sure your Universal analytics is set up correctly");
                  for (results = [], i = 0, len = (ref = this._queue).length; len > i; i++) item = ref[i], 
                  callback = this._remove_uuid(item.uuid), results.push(ga("send", "event", item.category, item.action, item.label, {
                    hitCallback: callback,
                    nonInteraction: 1
                  }));
                  return results;
                }, PersistentQueueGoogleAnalyticsAdapter.prototype._track = function(category, action, label) {
                  return utils.log("Persistent Queue Google Universal Analytics track: " + category + ", " + action + ", " + label), 
                  this._queue.length > 100 && this._queue.shift(), this._queue.push({
                    uuid: utils.uuid(),
                    category: category,
                    action: action,
                    label: label
                  }), this._storage.set(this.queue_name, JSON.stringify(this._queue)), this._flush();
                }, PersistentQueueGoogleAnalyticsAdapter.prototype.experiment_start = function(experiment, variant) {
                  return this._track(this.namespace, experiment.name + " | " + variant, "Visitors");
                }, PersistentQueueGoogleAnalyticsAdapter.prototype.goal_complete = function(experiment, variant, goal_name, _props) {
                  return this._track(this.namespace, experiment.name + " | " + variant, goal_name);
                }, PersistentQueueGoogleAnalyticsAdapter;
              }(), Adapters.PersistentQueueKeenAdapter = function() {
                function PersistentQueueKeenAdapter(keen_client, storage) {
                  null == storage && (storage = Adapters.LocalStorageAdapter), this.goal_complete = bind(this.goal_complete, this), 
                  this.experiment_start = bind(this.experiment_start, this), this.client = keen_client, 
                  this._storage = storage, this._queue = JSON.parse(this._storage.get(this.queue_name) || "[]"), 
                  this._flush();
                }
                return PersistentQueueKeenAdapter.prototype.queue_name = "_keen_queue", PersistentQueueKeenAdapter.prototype._remove_quuid = function(quuid) {
                  return _this = this, function(err, res) {
                    return err ? void 0 : (utils.remove(_this._queue, (function(el) {
                      return el.properties._quuid === quuid;
                    })), _this._storage.set(_this.queue_name, JSON.stringify(_this._queue)));
                  };
                  var _this;
                }, PersistentQueueKeenAdapter.prototype._flush = function() {
                  var callback, i, item, len, ref, results;
                  for (results = [], i = 0, len = (ref = this._queue).length; len > i; i++) item = ref[i], 
                  callback = this._remove_quuid(item.properties._quuid), results.push(this.client.addEvent(item.experiment_name, utils.omit(item.properties, "_quuid"), callback));
                  return results;
                }, PersistentQueueKeenAdapter.prototype._user_uuid = function(experiment, goal) {
                  return experiment.user_id && goal.unique ? utils.sha1(this.namespace + "." + experiment.name + "." + experiment.user_id) : utils.uuid();
                }, PersistentQueueKeenAdapter.prototype._track = function(experiment, variant, goal) {
                  return utils.log("Persistent Queue Keen track: " + experiment.name + ", " + variant + ", " + event), 
                  this._queue.length > 100 && this._queue.shift(), this._queue.push({
                    experiment_name: experiment.name,
                    properties: {
                      _quuid: utils.uuid(),
                      uuid: this._user_uuid(experiment, goal),
                      variant: variant,
                      event: goal.name
                    }
                  }), this._storage.set(this.queue_name, JSON.stringify(this._queue)), this._flush();
                }, PersistentQueueKeenAdapter.prototype.experiment_start = function(experiment, variant) {
                  return this._track(experiment, variant, {
                    name: "participate",
                    unique: !0
                  });
                }, PersistentQueueKeenAdapter.prototype.goal_complete = function(experiment, variant, goal_name, props) {
                  return this._track(experiment, variant, utils.defaults({
                    name: goal_name
                  }, props));
                }, PersistentQueueKeenAdapter;
              }(), Adapters.GoogleUniversalAnalyticsAdapter = function() {
                function GoogleUniversalAnalyticsAdapter() {}
                return GoogleUniversalAnalyticsAdapter.namespace = "alephbet", GoogleUniversalAnalyticsAdapter._track = function(category, action, label) {
                  if (utils.log("Google Universal Analytics track: " + category + ", " + action + ", " + label), 
                  "function" != typeof ga) throw new Error("ga not defined. Please make sure your Universal analytics is set up correctly");
                  return ga("send", "event", category, action, label, {
                    nonInteraction: 1
                  });
                }, GoogleUniversalAnalyticsAdapter.experiment_start = function(experiment, variant) {
                  return GoogleUniversalAnalyticsAdapter._track(GoogleUniversalAnalyticsAdapter.namespace, experiment.name + " | " + variant, "Visitors");
                }, GoogleUniversalAnalyticsAdapter.goal_complete = function(experiment, variant, goal_name, _props) {
                  return GoogleUniversalAnalyticsAdapter._track(GoogleUniversalAnalyticsAdapter.namespace, experiment.name + " | " + variant, goal_name);
                }, GoogleUniversalAnalyticsAdapter;
              }(), Adapters.LocalStorageAdapter = function() {
                function LocalStorageAdapter() {}
                return LocalStorageAdapter.namespace = "alephbet", LocalStorageAdapter.set = function(key, value) {
                  return new Storage(this.namespace).set(key, value);
                }, LocalStorageAdapter.get = function(key) {
                  return new Storage(this.namespace).get(key);
                }, LocalStorageAdapter;
              }(), Adapters;
            }(), module.exports = Adapters;
          }, {
            "./storage": 19,
            "./utils": 20
          } ],
          17: [ function(require, module, exports) {
            var AlephBet, adapters, options, utils, bind = function(fn, me) {
              return function() {
                return fn.apply(me, arguments);
              };
            };
            utils = require("./utils"), adapters = require("./adapters"), options = require("./options"), 
            AlephBet = function() {
              function AlephBet() {}
              return AlephBet.options = options, AlephBet.utils = utils, AlephBet.GimelAdapter = adapters.GimelAdapter, 
              AlephBet.PersistentQueueGoogleAnalyticsAdapter = adapters.PersistentQueueGoogleAnalyticsAdapter, 
              AlephBet.PersistentQueueKeenAdapter = adapters.PersistentQueueKeenAdapter, AlephBet.Experiment = function() {
                function Experiment(options1) {
                  this.options = null != options1 ? options1 : {}, this.add_goals = bind(this.add_goals, this), 
                  this.add_goal = bind(this.add_goal, this), utils.defaults(this.options, Experiment._options), 
                  _validate.call(this), this.name = this.options.name, this.variants = this.options.variants, 
                  this.user_id = this.options.user_id, this.variant_names = utils.keys(this.variants), 
                  _run.call(this);
                }
                var _run, _validate;
                return Experiment._options = {
                  name: null,
                  variants: null,
                  user_id: null,
                  sample: 1,
                  trigger: function() {
                    return !0;
                  },
                  tracking_adapter: adapters.GoogleUniversalAnalyticsAdapter,
                  storage_adapter: adapters.LocalStorageAdapter
                }, Experiment.prototype.run = function() {
                  var variant;
                  return utils.log("running with options: " + JSON.stringify(this.options)), (variant = this.get_stored_variant()) ? (utils.log(variant + " active"), 
                  this.activate_variant(variant)) : this.conditionally_activate_variant();
                }, _run = function() {
                  return this.run();
                }, Experiment.prototype.activate_variant = function(variant) {
                  var ref;
                  return null != (ref = this.variants[variant]) && ref.activate(this), this.storage().set(this.options.name + ":variant", variant);
                }, Experiment.prototype.conditionally_activate_variant = function() {
                  var variant;
                  if (this.options.trigger() && (utils.log("trigger set"), this.in_sample())) return utils.log("in sample"), 
                  variant = this.pick_variant(), this.tracking().experiment_start(this, variant), 
                  this.activate_variant(variant);
                }, Experiment.prototype.goal_complete = function(goal_name, props) {
                  var variant;
                  return null == props && (props = {}), utils.defaults(props, {
                    unique: !0
                  }), props.unique && this.storage().get(this.options.name + ":" + goal_name) || !(variant = this.get_stored_variant()) ? void 0 : (props.unique && this.storage().set(this.options.name + ":" + goal_name, !0), 
                  utils.log("experiment: " + this.options.name + " variant:" + variant + " goal:" + goal_name + " complete"), 
                  this.tracking().goal_complete(this, variant, goal_name, props));
                }, Experiment.prototype.get_stored_variant = function() {
                  return this.storage().get(this.options.name + ":variant");
                }, Experiment.prototype.pick_variant = function() {
                  var all_variants_have_weights;
                  return all_variants_have_weights = utils.check_weights(this.variants), utils.log("all variants have weights: " + all_variants_have_weights), 
                  all_variants_have_weights ? this.pick_weighted_variant() : this.pick_unweighted_variant();
                }, Experiment.prototype.pick_weighted_variant = function() {
                  var key, ref, weighted_index, weights_sum;
                  for (key in weights_sum = utils.sum_weights(this.variants), weighted_index = Math.ceil(this._random("variant") * weights_sum), 
                  ref = this.variants) if (0 >= (weighted_index -= ref[key].weight)) return key;
                }, Experiment.prototype.pick_unweighted_variant = function() {
                  var chosen_partition, partitions, variant;
                  return partitions = 1 / this.variant_names.length, chosen_partition = Math.floor(this._random("variant") / partitions), 
                  variant = this.variant_names[chosen_partition], utils.log(variant + " picked"), 
                  variant;
                }, Experiment.prototype.in_sample = function() {
                  var active;
                  return void 0 !== (active = this.storage().get(this.options.name + ":in_sample")) || (active = this._random("sample") <= this.options.sample, 
                  this.storage().set(this.options.name + ":in_sample", active)), active;
                }, Experiment.prototype._random = function(salt) {
                  var seed;
                  return this.user_id ? (seed = this.name + "." + salt + "." + this.user_id, utils.random(seed)) : utils.random();
                }, Experiment.prototype.add_goal = function(goal) {
                  return goal.add_experiment(this);
                }, Experiment.prototype.add_goals = function(goals) {
                  var goal, i, len, results;
                  for (results = [], i = 0, len = goals.length; len > i; i++) goal = goals[i], results.push(this.add_goal(goal));
                  return results;
                }, Experiment.prototype.storage = function() {
                  return this.options.storage_adapter;
                }, Experiment.prototype.tracking = function() {
                  return this.options.tracking_adapter;
                }, _validate = function() {
                  if (null === this.options.name) throw new Error("an experiment name must be specified");
                  if (null === this.options.variants) throw new Error("variants must be provided");
                  if ("function" != typeof this.options.trigger) throw new Error("trigger must be a function");
                  if (!utils.validate_weights(this.options.variants)) throw new Error("not all variants have weights");
                }, Experiment;
              }(), AlephBet.Goal = function() {
                function Goal(name, props1) {
                  this.name = name, this.props = null != props1 ? props1 : {}, utils.defaults(this.props, {
                    unique: !0
                  }), this.experiments = [];
                }
                return Goal.prototype.add_experiment = function(experiment) {
                  return this.experiments.push(experiment);
                }, Goal.prototype.add_experiments = function(experiments) {
                  var experiment, i, len, results;
                  for (results = [], i = 0, len = experiments.length; len > i; i++) experiment = experiments[i], 
                  results.push(this.add_experiment(experiment));
                  return results;
                }, Goal.prototype.complete = function() {
                  var experiment, i, len, ref, results;
                  for (results = [], i = 0, len = (ref = this.experiments).length; len > i; i++) experiment = ref[i], 
                  results.push(experiment.goal_complete(this.name, this.props));
                  return results;
                }, Goal;
              }(), AlephBet;
            }(), module.exports = AlephBet;
          }, {
            "./adapters": 16,
            "./options": 18,
            "./utils": 20
          } ],
          18: [ function(require, module, exports) {
            module.exports = {
              debug: !1
            };
          }, {} ],
          19: [ function(require, module, exports) {
            var Storage, store;
            store = require("store"), Storage = function() {
              function Storage(namespace) {
                if (this.namespace = null != namespace ? namespace : "alephbet", !store.enabled) throw new Error("local storage not supported");
                this.storage = store.get(this.namespace) || {};
              }
              return Storage.prototype.set = function(key, value) {
                return this.storage[key] = value, store.set(this.namespace, this.storage), value;
              }, Storage.prototype.get = function(key) {
                return this.storage[key];
              }, Storage;
            }(), module.exports = Storage;
          }, {
            store: 4
          } ],
          20: [ function(require, module, exports) {
            var Utils, _, options, sha1, uuid;
            _ = require("../vendor/lodash.custom.min"), uuid = require("node-uuid"), sha1 = require("crypto-js/sha1"), 
            options = require("./options"), Utils = function() {
              function Utils() {}
              return Utils.defaults = _.defaults, Utils.keys = _.keys, Utils.remove = _.remove, 
              Utils.omit = _.omit, Utils.log = function(message) {
                return options.debug ? console.log(message) : void 0;
              }, Utils.uuid = uuid.v4, Utils.sha1 = function(text) {
                return sha1(text).toString();
              }, Utils.random = function(seed) {
                return seed ? parseInt(this.sha1(seed).substr(0, 13), 16) / 0xfffffffffffff : Math.random();
              }, Utils.check_weights = function(variants) {
                var contains_weight, key, value;
                for (key in contains_weight = [], variants) value = variants[key], contains_weight.push(null != value.weight);
                return contains_weight.every((function(has_weight) {
                  return has_weight;
                }));
              }, Utils.sum_weights = function(variants) {
                var key, sum;
                for (key in sum = 0, variants) sum += variants[key].weight || 0;
                return sum;
              }, Utils.validate_weights = function(variants) {
                var contains_weight, key, value;
                for (key in contains_weight = [], variants) value = variants[key], contains_weight.push(null != value.weight);
                return contains_weight.every((function(has_weight) {
                  return has_weight || contains_weight.every((function(has_weight) {
                    return !has_weight;
                  }));
                }));
              }, Utils;
            }(), module.exports = Utils;
          }, {
            "../vendor/lodash.custom.min": 21,
            "./options": 18,
            "crypto-js/sha1": 2,
            "node-uuid": 3
          } ],
          21: [ function(require, module, exports) {
            (function(global) {
              (function() {
                function na(a, b, c) {
                  if (b != b) {
                    a: {
                      for (b = a.length, c += -1; ++c < b; ) {
                        var e = a[c];
                        if (e != e) {
                          a = c;
                          break a;
                        }
                      }
                      a = -1;
                    }
                    return a;
                  }
                  for (c -= 1, e = a.length; ++c < e; ) if (a[c] === b) return c;
                  return -1;
                }
                function A(a) {
                  return !!a && "object" == typeof a;
                }
                function m() {}
                function xa(a) {
                  var b = a ? a.length : 0;
                  for (this.data = {
                    hash: ya(null),
                    set: new za
                  }; b--; ) this.push(a[b]);
                }
                function Za(a, b) {
                  var c = a.data;
                  return ("string" == typeof b || t(b) ? c.set.has(b) : c.hash[b]) ? 0 : -1;
                }
                function Aa(a, b) {
                  for (var c = -1, e = a.length; ++c < e && !1 !== b(a[c], c, a); ) ;
                  return a;
                }
                function bb(a, b) {
                  for (var c = -1, e = a.length; ++c < e; ) if (b(a[c], c, a)) return !0;
                  return !1;
                }
                function Ba(a, b) {
                  var c;
                  if (null == b) c = a; else {
                    var e = a;
                    e || (e = {});
                    for (var d = -1, f = (c = C(b)).length; ++d < f; ) {
                      var h = c[d];
                      e[h] = b[h];
                    }
                    c = e;
                  }
                  return c;
                }
                function Ca(a, b, c) {
                  var e = typeof a;
                  return "function" == e ? b === p ? a : oa(a, b, c) : null == a ? Q : "object" == e ? Da(a) : b === p ? Ea(a) : function(a, b) {
                    var c = x(a), e = Ja(a) && b == b && !t(b), d = a + "";
                    return a = Ka(a), function(f) {
                      if (null == f) return !1;
                      var h = d;
                      if (f = y(f), !(!c && e || h in f)) {
                        if (1 != a.length) {
                          var g = 0, l = -1, n = -1, k = (h = a).length;
                          for (0 > (g = null == g ? 0 : +g || 0) && (g = -g > k ? 0 : k + g), 0 > (l = l === p || l > k ? k : +l || 0) && (l += k), 
                          k = g > l ? 0 : l - g >>> 0, g >>>= 0, l = Array(k); ++n < k; ) l[n] = h[n + g];
                          f = Ia(f, l);
                        }
                        if (null == f) return !1;
                        h = La(a), f = y(f);
                      }
                      return f[h] === b ? b !== p || h in f : qa(b, f[h], p, !0);
                    };
                  }(a, b);
                }
                function Fa(a, b, c, e, d, f, h) {
                  var g;
                  if (c && (g = d ? c(a, e, d) : c(a)), g !== p) return g;
                  if (!t(a)) return a;
                  if (e = x(a)) {
                    if (g = function(a) {
                      var b = a.length, c = new a.constructor(b);
                      return b && "string" == typeof a[0] && v.call(a, "index") && (c.index = a.index, 
                      c.input = a.input), c;
                    }(a), !b) return function(a, b) {
                      var c = -1, e = a.length;
                      for (b || (b = Array(e)); ++c < e; ) b[c] = a[c];
                      return b;
                    }(a, g);
                  } else {
                    var l = B.call(a), n = l == G;
                    if (l != u && l != H && (!n || d)) return r[l] ? function(a, b, c) {
                      var e = a.constructor;
                      switch (b) {
                       case ta:
                        return Na(a);

                       case I:
                       case J:
                        return new e(+a);

                       case W:
                       case X:
                       case Y:
                       case Z:
                       case $:
                       case aa:
                       case ba:
                       case ca:
                       case da:
                        return e instanceof e && (e = z[b]), b = a.buffer, new e(c ? Na(b) : b, a.byteOffset, a.length);

                       case L:
                       case D:
                        return new e(a);

                       case M:
                        var d = new e(a.source, rb.exec(a));
                        d.lastIndex = a.lastIndex;
                      }
                      return d;
                    }(a, l, b) : d ? a : {};
                    if (R(a)) return d ? a : {};
                    if (g = function(a) {
                      return "function" == typeof (a = a.constructor) && a instanceof a || (a = Object), 
                      new a;
                    }(n ? {} : a), !b) return Ba(g, a);
                  }
                  for (f || (f = []), h || (h = []), d = f.length; d--; ) if (f[d] == a) return h[d];
                  return f.push(a), h.push(g), (e ? Aa : gb)(a, (function(e, d) {
                    g[d] = Fa(e, b, c, d, a, f, h);
                  })), g;
                }
                function Ga(a, b, c, e) {
                  e || (e = []);
                  for (var d = -1, f = a.length; ++d < f; ) {
                    var h = a[d];
                    if (A(h) && S(h) && (c || x(h) || T(h))) if (b) Ga(h, b, c, e); else for (var g = e, l = -1, n = h.length, k = g.length; ++l < n; ) g[k + l] = h[l]; else c || (e[e.length] = h);
                  }
                  return e;
                }
                function gb(a, b) {
                  return Ha(a, b, C);
                }
                function Ia(a, b, c) {
                  if (null != a) {
                    a = y(a), c !== p && c in a && (b = [ c ]), c = 0;
                    for (var e = b.length; null != a && e > c; ) a = y(a)[b[c++]];
                    return c && c == e ? a : p;
                  }
                }
                function qa(a, b, c, e, d, f) {
                  if (a === b) a = !0; else if (null == a || null == b || !t(a) && !A(b)) a = a != a && b != b; else a: {
                    var h = qa, g = x(a), l = x(b), n = E, k = E;
                    g || ((n = B.call(a)) == H ? n = u : n != u && (g = ra(a))), l || ((k = B.call(b)) == H ? k = u : k != u && ra(b));
                    var p = n == u && !R(a);
                    if (l = k == u && !R(b), !(k = n == k) || g || p) {
                      if (!e && (n = p && v.call(a, "__wrapped__"), l = l && v.call(b, "__wrapped__"), 
                      n || l)) {
                        a = h(n ? a.value() : a, l ? b.value() : b, c, e, d, f);
                        break a;
                      }
                      if (k) {
                        for (d || (d = []), f || (f = []), n = d.length; n--; ) if (d[n] == a) {
                          a = f[n] == b;
                          break a;
                        }
                        d.push(a), f.push(b), a = (g ? kb : lb)(a, b, h, c, e, d, f), d.pop(), f.pop();
                      } else a = !1;
                    } else a = function(a, b, c) {
                      switch (c) {
                       case I:
                       case J:
                        return +a == +b;

                       case K:
                        return a.name == b.name && a.message == b.message;

                       case L:
                        return a != +a ? b != +b : a == +b;

                       case M:
                       case D:
                        return a == b + "";
                      }
                      return !1;
                    }(a, b, n);
                  }
                  return a;
                }
                function Da(a) {
                  var b = function(a) {
                    for (var b = (a = Oa(a)).length; b--; ) {
                      var c = a[b][1];
                      a[b][2] = c == c && !t(c);
                    }
                    return a;
                  }(a);
                  if (1 == b.length && b[0][2]) {
                    var c = b[0][0], e = b[0][1];
                    return function(a) {
                      return null != a && (a = y(a))[c] === e && (e !== p || c in a);
                    };
                  }
                  return function(a) {
                    return function(a, b) {
                      var c = b.length, e = c;
                      if (null == a) return !e;
                      for (a = y(a); c--; ) if ((d = b[c])[2] ? d[1] !== a[d[0]] : !(d[0] in a)) return !1;
                      for (;++c < e; ) {
                        var d, f = (d = b[c])[0], h = a[f], g = d[1];
                        if (d[2]) {
                          if (h === p && !(f in a)) return !1;
                        } else if ((d = p) === p ? !qa(g, h, void 0, !0) : !d) return !1;
                      }
                      return !0;
                    }(a, b);
                  };
                }
                function Ma(a) {
                  return function(b) {
                    return null == b ? p : y(b)[a];
                  };
                }
                function oa(a, b, c) {
                  if ("function" != typeof a) return Q;
                  if (b === p) return a;
                  switch (c) {
                   case 1:
                    return function(c) {
                      return a.call(b, c);
                    };

                   case 3:
                    return function(c, d, f) {
                      return a.call(b, c, d, f);
                    };

                   case 4:
                    return function(c, d, f, h) {
                      return a.call(b, c, d, f, h);
                    };

                   case 5:
                    return function(c, d, f, h, g) {
                      return a.call(b, c, d, f, h, g);
                    };
                  }
                  return function() {
                    return a.apply(b, arguments);
                  };
                }
                function Na(a) {
                  var b = new qb(a.byteLength);
                  return new sa(b).set(new sa(a)), b;
                }
                function kb(a, b, c, e, d, f, h) {
                  var g = -1, l = a.length;
                  if (l != (n = b.length) && !(d && n > l)) return !1;
                  for (;++g < l; ) {
                    var k = a[g], n = b[g], m = e ? e(d ? n : k, d ? k : n, g) : p;
                    if (m !== p) {
                      if (m) continue;
                      return !1;
                    }
                    if (d) {
                      if (!bb(b, (function(a) {
                        return k === a || c(k, a, e, d, f, h);
                      }))) return !1;
                    } else if (k !== n && !c(k, n, e, d, f, h)) return !1;
                  }
                  return !0;
                }
                function lb(a, b, c, e, d, f, h) {
                  var g = C(a), l = g.length, n = C(b).length;
                  if (l != n && !d) return !1;
                  for (n = l; n--; ) {
                    var k = g[n];
                    if (!(d ? k in b : v.call(b, k))) return !1;
                  }
                  for (var m = d; ++n < l; ) {
                    var r = a[k = g[n]], q = b[k], s = e ? e(d ? q : r, d ? r : q, k) : p;
                    if (s === p ? !c(r, q, e, d, f, h) : !s) return !1;
                    m || (m = "constructor" == k);
                  }
                  return !(!m && (c = a.constructor, e = b.constructor, c != e && "constructor" in a && "constructor" in b && !("function" == typeof c && c instanceof c && "function" == typeof e && e instanceof e)));
                }
                function V(a, b) {
                  var c = null == a ? p : a[b];
                  return Pa(c) ? c : p;
                }
                function S(a) {
                  return null != a && N(sb(a));
                }
                function ea(a, b) {
                  return a = "number" == typeof a || tb.test(a) ? +a : -1, b = null == b ? Qa : b, 
                  a > -1 && 0 == a % 1 && b > a;
                }
                function Ra(a, b, c) {
                  if (!t(c)) return !1;
                  var e = typeof b;
                  return !!("number" == e ? S(c) && ea(b, c.length) : "string" == e && b in c) && (b = c[b], 
                  a == a ? a === b : b != b);
                }
                function Ja(a) {
                  var b = typeof a;
                  return !(!("string" == b && ub.test(a) || "number" == b) && (x(a) || vb.test(a)));
                }
                function N(a) {
                  return "number" == typeof a && a > -1 && 0 == a % 1 && Qa >= a;
                }
                function xb(a, b) {
                  var c = {};
                  return function(a, b) {
                    Ha(a, b, U);
                  }(a, (function(a, d, f) {
                    b(a, d, f) && (c[d] = a);
                  })), c;
                }
                function Sa(a) {
                  for (var b = U(a), c = b.length, e = c && a.length, d = !!e && N(e) && (x(a) || T(a) || fa(a)), f = -1, h = []; ++f < c; ) {
                    var g = b[f];
                    (d && ea(g, e) || v.call(a, g)) && h.push(g);
                  }
                  return h;
                }
                function y(a) {
                  if (m.support.unindexedChars && fa(a)) {
                    for (var b = -1, c = a.length, e = Object(a); ++b < c; ) e[b] = a.charAt(b);
                    return e;
                  }
                  return t(a) ? a : Object(a);
                }
                function Ka(a) {
                  if (x(a)) return a;
                  var b = [];
                  return (null == a ? "" : a + "").replace(yb, (function(a, e, d, f) {
                    b.push(d ? f.replace(zb, "$1") : e || a);
                  })), b;
                }
                function pa(a, b, c) {
                  var e = a ? a.length : 0;
                  if (!e) return -1;
                  if ("number" == typeof c) c = 0 > c ? ua(e + c, 0) : c; else if (c) {
                    c = 0;
                    var d = a ? a.length : c;
                    if ("number" == typeof b && b == b && Ab >= d) {
                      for (;d > c; ) b > (h = a[f = c + d >>> 1]) && null !== h ? c = f + 1 : d = f;
                      c = d;
                    } else {
                      c = (d = Q)(b);
                      for (var f = 0, h = a ? a.length : 0, g = c != c, l = null === c, n = c === p; h > f; ) {
                        var k = Bb((f + h) / 2), m = d(a[k]), r = m !== p, q = m == m;
                        (g ? q : l ? q && r && null != m : n ? q && r : null != m && c > m) ? f = k + 1 : h = k;
                      }
                      c = Cb(h, Db);
                    }
                    return e > c && (b == b ? b === a[c] : a[c] != a[c]) ? c : -1;
                  }
                  return na(a, b, c || 0);
                }
                function La(a) {
                  var b = a ? a.length : 0;
                  return b ? a[b - 1] : p;
                }
                function ga(a, b) {
                  if ("function" != typeof a) throw new TypeError(Eb);
                  return b = ua(b === p ? a.length - 1 : +b || 0, 0), function() {
                    for (var c = arguments, e = -1, d = ua(c.length - b, 0), f = Array(d); ++e < d; ) f[e] = c[b + e];
                    switch (b) {
                     case 0:
                      return a.call(this, f);

                     case 1:
                      return a.call(this, c[0], f);

                     case 2:
                      return a.call(this, c[0], c[1], f);
                    }
                    for (d = Array(b + 1), e = -1; ++e < b; ) d[e] = c[e];
                    return d[b] = f, a.apply(this, d);
                  };
                }
                function T(a) {
                  return A(a) && S(a) && v.call(a, "callee") && !ha.call(a, "callee");
                }
                function ia(a) {
                  return t(a) && B.call(a) == G;
                }
                function t(a) {
                  var b = typeof a;
                  return !!a && ("object" == b || "function" == b);
                }
                function Pa(a) {
                  return null != a && (ia(a) ? Ta.test(Ua.call(a)) : A(a) && (R(a) ? Ta : Fb).test(a));
                }
                function fa(a) {
                  return "string" == typeof a || A(a) && B.call(a) == D;
                }
                function ra(a) {
                  return A(a) && N(a.length) && !!q[B.call(a)];
                }
                function U(a) {
                  if (null == a) return [];
                  t(a) || (a = Object(a));
                  for (var e, b = a.length, c = m.support, d = (b = b && N(b) && (x(a) || T(a) || fa(a)) && b || 0, 
                  -1), f = (e = ia(e = a.constructor) && e.prototype || F) === a, h = Array(b), g = b > 0, l = c.enumErrorProps && (a === ja || a instanceof Error), n = c.enumPrototypes && ia(a); ++d < b; ) h[d] = d + "";
                  for (var k in a) n && "prototype" == k || l && ("message" == k || "name" == k) || g && ea(k, b) || "constructor" == k && (f || !v.call(a, k)) || h.push(k);
                  if (c.nonEnumShadows && a !== F) for (b = a === Gb ? D : a === ja ? K : B.call(a), 
                  c = s[b] || s[u], b == u && (e = F), b = va.length; b--; ) d = c[k = va[b]], f && d || (d ? !v.call(a, k) : a[k] === e[k]) || h.push(k);
                  return h;
                }
                function Oa(a) {
                  a = y(a);
                  for (var b = -1, c = C(a), e = c.length, d = Array(e); ++b < e; ) {
                    var f = c[b];
                    d[b] = [ f, a[f] ];
                  }
                  return d;
                }
                function ka(a, b, c) {
                  return c && Ra(a, b, c) && (b = p), A(a) ? Va(a) : Ca(a, b);
                }
                function Q(a) {
                  return a;
                }
                function Va(a) {
                  return Da(Fa(a, !0));
                }
                function Ea(a) {
                  return Ja(a) ? Ma(a) : function(a) {
                    var b = a + "";
                    return a = Ka(a), function(c) {
                      return Ia(c, a, b);
                    };
                  }(a);
                }
                var p, ib = 200, Eb = "Expected a function", H = "[object Arguments]", E = "[object Array]", I = "[object Boolean]", J = "[object Date]", K = "[object Error]", G = "[object Function]", L = "[object Number]", u = "[object Object]", M = "[object RegExp]", D = "[object String]", ta = "[object ArrayBuffer]", W = "[object Float32Array]", X = "[object Float64Array]", Y = "[object Int8Array]", Z = "[object Int16Array]", $ = "[object Int32Array]", aa = "[object Uint8Array]", ba = "[object Uint8ClampedArray]", ca = "[object Uint16Array]", da = "[object Uint32Array]", vb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/, ub = /^\w*$/, yb = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g, zb = /\\(\\)?/g, rb = /\w*$/, Fb = /^\[object .+?Constructor\]$/, tb = /^\d+$/, va = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), q = {};
                q[W] = q[X] = q[Y] = q[Z] = q[$] = q[aa] = q[ba] = q[ca] = q[da] = !0, q[H] = q[E] = q[ta] = q[I] = q[J] = q[K] = q[G] = q["[object Map]"] = q[L] = q[u] = q[M] = q["[object Set]"] = q[D] = q["[object WeakMap]"] = !1;
                var r = {};
                r[H] = r[E] = r[ta] = r[I] = r[J] = r[W] = r[X] = r[Y] = r[Z] = r[$] = r[L] = r[u] = r[M] = r[D] = r[aa] = r[ba] = r[ca] = r[da] = !0, 
                r[K] = r[G] = r["[object Map]"] = r["[object Set]"] = r["[object WeakMap]"] = !1;
                var la = {
                  function: !0,
                  object: !0
                }, ma = la[typeof exports] && exports && !exports.nodeType && exports, O = la[typeof module] && module && !module.nodeType && module, Hb = la[typeof self] && self && self.Object && self, Wa = la[typeof window] && window && window.Object && window, Ib = O && O.exports === ma && ma, w = ma && O && "object" == typeof global && global && global.Object && global || Wa !== (this && this.window) && Wa || Hb || this, R = function() {
                  try {
                    Object({
                      toString: 0
                    } + "");
                  } catch (a) {
                    return function() {
                      return !1;
                    };
                  }
                  return function(a) {
                    return "function" != typeof a.toString && "string" == typeof (a + "");
                  };
                }(), Jb = Array.prototype, ja = Error.prototype, F = Object.prototype, Gb = String.prototype, Ua = Function.prototype.toString, v = F.hasOwnProperty, B = F.toString, Ta = RegExp("^" + Ua.call(v).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), qb = w.ArrayBuffer, ha = F.propertyIsEnumerable, za = V(w, "Set"), Xa = Jb.splice, sa = w.Uint8Array, ya = V(Object, "create"), Bb = Math.floor, Kb = V(Array, "isArray"), Ya = V(Object, "keys"), ua = Math.max, Cb = Math.min, Db = 4294967294, Ab = 2147483647, Qa = 9007199254740991, z = {};
                z[W] = w.Float32Array, z[X] = w.Float64Array, z[Y] = w.Int8Array, z[Z] = w.Int16Array, 
                z[$] = w.Int32Array, z[aa] = sa, z[ba] = w.Uint8ClampedArray, z[ca] = w.Uint16Array, 
                z[da] = w.Uint32Array;
                var s = {};
                s[E] = s[J] = s[L] = {
                  constructor: !0,
                  toLocaleString: !0,
                  toString: !0,
                  valueOf: !0
                }, s[I] = s[D] = {
                  constructor: !0,
                  toString: !0,
                  valueOf: !0
                }, s[K] = s[G] = s[M] = {
                  constructor: !0,
                  toString: !0
                }, s[u] = {
                  constructor: !0
                }, Aa(va, (function(a) {
                  for (var b in s) if (v.call(s, b)) {
                    var c = s[b];
                    c[a] = v.call(c, a);
                  }
                }));
                var P = m.support = {};
                !function(a) {
                  function b() {
                    this.x = 1;
                  }
                  var c = {
                    0: 1,
                    length: 1
                  }, e = [];
                  for (var d in b.prototype = {
                    valueOf: 1,
                    y: 1
                  }, new b) e.push(d);
                  P.enumErrorProps = ha.call(ja, "message") || ha.call(ja, "name"), P.enumPrototypes = ha.call(b, "prototype"), 
                  P.nonEnumShadows = !/valueOf/.test(e), P.spliceObjects = (Xa.call(c, 0, 1), !c[0]), 
                  P.unindexedChars = "xx" != "x"[0] + Object("x")[0];
                }();
                var a, Ha = function(b, c, e) {
                  for (var d = y(b), f = (e = e(b)).length, h = -1; ++h < f; ) {
                    var g = e[h];
                    if (!1 === c(d[g], g, d)) break;
                  }
                  return b;
                }, sb = Ma("length"), x = Kb || function(a) {
                  return A(a) && N(a.length) && B.call(a) == E;
                }, wa = (a = function(a, b, c) {
                  if (c) for (var e = -1, d = C(b), f = d.length; ++e < f; ) {
                    var h = d[e], g = a[h], l = c(g, b[h], h, a, b);
                    (l == l ? l === g : g != g) && (g !== p || h in a) || (a[h] = l);
                  } else a = Ba(a, b);
                  return a;
                }, ga((function(b, c) {
                  var e = -1, d = null == b ? 0 : c.length, f = d > 2 ? c[d - 2] : p, h = d > 2 ? c[2] : p, g = d > 1 ? c[d - 1] : p;
                  for ("function" == typeof f ? (f = oa(f, g, 5), d -= 2) : d -= (f = "function" == typeof g ? g : p) ? 1 : 0, 
                  h && Ra(c[0], c[1], h) && (f = 3 > d ? p : f, d = 1); ++e < d; ) (h = c[e]) && a(b, h, f);
                  return b;
                }))), Lb = function(a, b) {
                  return ga((function(c) {
                    var e = c[0];
                    return null == e ? e : (c.push(b), a.apply(p, c));
                  }));
                }(wa, (function(a, b) {
                  return a === p ? b : a;
                })), C = Ya ? function(a) {
                  var b = null == a ? p : a.constructor;
                  return "function" == typeof b && b.prototype === a || ("function" == typeof a ? m.support.enumPrototypes : S(a)) ? Sa(a) : t(a) ? Ya(a) : [];
                } : Sa, Mb = ga((function(a, b) {
                  if (null == a) return {};
                  if ("function" != typeof b[0]) return b = function(a) {
                    for (var b = String, c = -1, e = a.length, d = Array(e); ++c < e; ) d[c] = b(a[c], c, a);
                    return d;
                  }(Ga(b)), function(a, b) {
                    a = y(a);
                    for (var c = -1, e = b.length, d = {}; ++c < e; ) {
                      var f = b[c];
                      f in a && (d[f] = a[f]);
                    }
                    return d;
                  }(a, function(a, b) {
                    var c = a ? a.length : 0, e = [];
                    if (!c) return e;
                    var f, d = -1, h = (f = (f = m.indexOf || pa) === pa ? na : f) === na, g = h && b.length >= ib && ya && za ? new xa(b) : null, l = b.length;
                    g && (f = Za, h = !1, b = g);
                    a: for (;++d < c; ) if (g = a[d], h && g == g) {
                      for (var n = l; n--; ) if (b[n] === g) continue a;
                      e.push(g);
                    } else 0 > f(b, g, 0) && e.push(g);
                    return e;
                  }(U(a), b));
                  var c = oa(b[0], b[1], 3);
                  return xb(a, (function(a, b, f) {
                    return !c(a, b, f);
                  }));
                }));
                xa.prototype.push = function(a) {
                  var b = this.data;
                  "string" == typeof a || t(a) ? b.set.add(a) : b.hash[a] = !0;
                }, m.assign = wa, m.callback = ka, m.defaults = Lb, m.keys = C, m.keysIn = U, m.matches = Va, 
                m.omit = Mb, m.pairs = Oa, m.property = Ea, m.remove = function(a, b, c) {
                  var e = [];
                  if (!a || !a.length) return e;
                  var g, d = -1, f = [], h = a.length;
                  for (b = (g = (g = m.callback || ka) === ka ? Ca : g)(b, c, 3); ++d < h; ) b(c = a[d], d, a) && (e.push(c), 
                  f.push(d));
                  for (b = a ? f.length : 0; b--; ) if ((d = f[b]) != l && ea(d)) {
                    var l = d;
                    Xa.call(a, d, 1);
                  }
                  return e;
                }, m.restParam = ga, m.extend = wa, m.iteratee = ka, m.identity = Q, m.indexOf = pa, 
                m.isArguments = T, m.isArray = x, m.isFunction = ia, m.isNative = Pa, m.isObject = t, 
                m.isString = fa, m.isTypedArray = ra, m.last = La, m.VERSION = "3.10.1", ma && O && Ib && ((O.exports = m)._ = m);
              }).call(this);
            }).call(this, void 0 !== __webpack_require__.g ? __webpack_require__.g : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {} ]
        }, {}, [ 17 ])(17);
      }, module.exports = f();
    },
    520: function(module, __unused_webpack___webpack_exports__, __webpack_require__) {
      "use strict";
      var _alephbet_min_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(864);
      module = __webpack_require__.hmd(module);
      var lazyLoad = function() {
        var counter = 0, temps = [], lazies = document.querySelectorAll("[data-image]");
        [].forEach.call(lazies, (function(elem) {
          if (elem.hasAttribute("data-image") && (function(elem) {
            var distance = elem.getBoundingClientRect();
            return distance.top >= -200 && distance.bottom <= 2 * (window.innerHeight || document.documentElement.clientHeight) && distance.left >= 0 && distance.right <= (window.innerWidth || document.documentElement.clientWidth);
          }(elem) || elem.hasAttribute("data-preload"))) {
            var src = elem.hasAttribute("data-image-mobile") && window.innerWidth <= 720 ? elem.getAttribute("data-image-mobile") : elem.getAttribute("data-image");
            if ("IMG" == elem.tagName) {
              if (elem.src == src) return !0;
              elem.src = src, temps[counter] = elem;
            } else {
              if (elem.style.backgroundImage = "url(" + src + ")") return !0;
              temps[counter] = document.createElement("img");
              elem.hasAttribute("data-preload");
              temps[counter].addEventListener("load", (function() {
                !function(elem, temp, opacity) {
                  var src = elem.hasAttribute("data-image-mobile") && window.innerWidth <= 720 ? elem.getAttribute("data-image-mobile") : elem.getAttribute("data-image");
                  elem.style.backgroundImage = "url(" + src + ")", temp.remove();
                }(elem, this);
              })), temps[counter].src = src;
            }
          }
          counter += 1;
        }));
      };
      window.addEventListener("load", (function() {
        lazyLoad();
      })), window.addEventListener("scroll", (function() {
        lazyLoad();
      })), window.addEventListener("resize", (function() {
        lazyLoad();
      }));
      var body = document.querySelector("body"), header = document.querySelector("header"), lastScrollTop = 0, didScroll = !0;
      window.addEventListener("scroll", (function(event) {
        didScroll = !0;
      })), setInterval((function() {
        didScroll && (!function() {
          var st = window.pageYOffset || document.documentElement.scrollTop;
          if (Math.abs(lastScrollTop - st) <= 5) return;
          st > header.clientHeight ? body.classList.add("fixed") : body.classList.remove("fixed");
          lastScrollTop = st;
        }(), didScroll = !1);
      }), 250);
      var tns = function() {
        var win = window, raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || function(cb) {
          return setTimeout(cb, 16);
        }, win$1 = window, caf = win$1.cancelAnimationFrame || win$1.mozCancelAnimationFrame || function(id) {
          clearTimeout(id);
        };
        function extend() {
          for (var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length; i < length; i++) if (null !== (obj = arguments[i])) for (name in obj) target !== (copy = obj[name]) && void 0 !== copy && (target[name] = copy);
          return target;
        }
        function checkStorageValue(value) {
          return [ "true", "false" ].indexOf(value) >= 0 ? JSON.parse(value) : value;
        }
        function setLocalStorage(storage, key, value, access) {
          if (access) try {
            storage.setItem(key, value);
          } catch (e) {}
          return value;
        }
        function getBody() {
          var doc = document, body = doc.body;
          return body || ((body = doc.createElement("body")).fake = !0), body;
        }
        var docElement = document.documentElement;
        function setFakeBody(body) {
          var docOverflow = "";
          return body.fake && (docOverflow = docElement.style.overflow, body.style.background = "", 
          body.style.overflow = docElement.style.overflow = "hidden", docElement.appendChild(body)), 
          docOverflow;
        }
        function resetFakeBody(body, docOverflow) {
          body.fake && (body.remove(), docElement.style.overflow = docOverflow, docElement.offsetHeight);
        }
        function addCSSRule(sheet, selector, rules, index) {
          "insertRule" in sheet ? sheet.insertRule(selector + "{" + rules + "}", index) : sheet.addRule(selector, rules, index);
        }
        function getCssRulesLength(sheet) {
          return ("insertRule" in sheet ? sheet.cssRules : sheet.rules).length;
        }
        function forEachNodeList(arr, callback, scope) {
          for (var i = 0, l = arr.length; i < l; i++) callback.call(scope, arr[i], i);
        }
        var classListSupport = "classList" in document.createElement("_"), hasClass = classListSupport ? function(el, str) {
          return el.classList.contains(str);
        } : function(el, str) {
          return el.className.indexOf(str) >= 0;
        }, addClass = classListSupport ? function(el, str) {
          hasClass(el, str) || el.classList.add(str);
        } : function(el, str) {
          hasClass(el, str) || (el.className += " " + str);
        }, removeClass = classListSupport ? function(el, str) {
          hasClass(el, str) && el.classList.remove(str);
        } : function(el, str) {
          hasClass(el, str) && (el.className = el.className.replace(str, ""));
        };
        function hasAttr(el, attr) {
          return el.hasAttribute(attr);
        }
        function getAttr(el, attr) {
          return el.getAttribute(attr);
        }
        function isNodeList(el) {
          return void 0 !== el.item;
        }
        function setAttrs(els, attrs) {
          if (els = isNodeList(els) || els instanceof Array ? els : [ els ], "[object Object]" === Object.prototype.toString.call(attrs)) for (var i = els.length; i--; ) for (var key in attrs) els[i].setAttribute(key, attrs[key]);
        }
        function removeAttrs(els, attrs) {
          els = isNodeList(els) || els instanceof Array ? els : [ els ];
          for (var attrLength = (attrs = attrs instanceof Array ? attrs : [ attrs ]).length, i = els.length; i--; ) for (var j = attrLength; j--; ) els[i].removeAttribute(attrs[j]);
        }
        function arrayFromNodeList(nl) {
          for (var arr = [], i = 0, l = nl.length; i < l; i++) arr.push(nl[i]);
          return arr;
        }
        function hideElement(el, forceHide) {
          "none" !== el.style.display && (el.style.display = "none");
        }
        function showElement(el, forceHide) {
          "none" === el.style.display && (el.style.display = "");
        }
        function isVisible(el) {
          return "none" !== window.getComputedStyle(el).display;
        }
        function whichProperty(props) {
          if ("string" == typeof props) {
            var arr = [ props ], Props = props.charAt(0).toUpperCase() + props.substr(1);
            [ "Webkit", "Moz", "ms", "O" ].forEach((function(prefix) {
              "ms" === prefix && "transform" !== props || arr.push(prefix + Props);
            })), props = arr;
          }
          for (var el = document.createElement("fakeelement"), i = (props.length, 0); i < props.length; i++) {
            var prop = props[i];
            if (void 0 !== el.style[prop]) return prop;
          }
          return !1;
        }
        function getEndProperty(propIn, propOut) {
          var endProp = !1;
          return /^Webkit/.test(propIn) ? endProp = "webkit" + propOut + "End" : /^O/.test(propIn) ? endProp = "o" + propOut + "End" : propIn && (endProp = propOut.toLowerCase() + "end"), 
          endProp;
        }
        var passiveOption = !!supportsPassive && {
          passive: !0
        };
        function addEvents(el, obj) {
          for (var prop in obj) {
            var option = ("touchstart" === prop || "touchmove" === prop) && passiveOption;
            el.addEventListener(prop, obj[prop], option);
          }
        }
        var supportsPassive = !1;
        try {
          var opts = Object.defineProperty({}, "passive", {
            get: function() {
              supportsPassive = !0;
            }
          });
          window.addEventListener("test", null, opts);
        } catch (e) {}
        function removeEvents(el, obj) {
          for (var prop in obj) {
            var option = [ "touchstart", "touchmove" ].indexOf(prop) >= 0 && passiveOption;
            el.removeEventListener(prop, obj[prop], option);
          }
        }
        function Events() {
          return {
            topics: {},
            on: function(eventName, fn) {
              this.topics[eventName] = this.topics[eventName] || [], this.topics[eventName].push(fn);
            },
            off: function(eventName, fn) {
              if (this.topics[eventName]) for (var i = 0; i < this.topics[eventName].length; i++) if (this.topics[eventName][i] === fn) {
                this.topics[eventName].splice(i, 1);
                break;
              }
            },
            emit: function(eventName, data) {
              data.type = eventName, this.topics[eventName] && this.topics[eventName].forEach((function(fn) {
                fn(data, eventName);
              }));
            }
          };
        }
        Object.keys || (Object.keys = function(object) {
          var keys = [];
          for (var name in object) Object.prototype.hasOwnProperty.call(object, name) && keys.push(name);
          return keys;
        }), "remove" in Element.prototype || (Element.prototype.remove = function() {
          this.parentNode && this.parentNode.removeChild(this);
        });
        var tns = function(options) {
          options = extend({
            container: ".slider",
            mode: "carousel",
            axis: "horizontal",
            items: 1,
            gutter: 0,
            edgePadding: 0,
            fixedWidth: !1,
            autoWidth: !1,
            viewportMax: !1,
            slideBy: 1,
            center: !1,
            controls: !0,
            controlsPosition: "top",
            controlsText: [ "prev", "next" ],
            controlsContainer: !1,
            prevButton: !1,
            nextButton: !1,
            nav: !0,
            navPosition: "top",
            navContainer: !1,
            navAsThumbnails: !1,
            arrowKeys: !1,
            speed: 300,
            autoplay: !1,
            autoplayPosition: "top",
            autoplayTimeout: 5e3,
            autoplayDirection: "forward",
            autoplayText: [ "start", "stop" ],
            autoplayHoverPause: !1,
            autoplayButton: !1,
            autoplayButtonOutput: !0,
            autoplayResetOnVisibility: !0,
            animateIn: "tns-fadeIn",
            animateOut: "tns-fadeOut",
            animateNormal: "tns-normal",
            animateDelay: !1,
            loop: !0,
            rewind: !1,
            autoHeight: !1,
            responsive: !1,
            lazyload: !1,
            lazyloadSelector: ".tns-lazy-img",
            touch: !0,
            mouseDrag: !1,
            swipeAngle: 15,
            nested: !1,
            preventActionWhenRunning: !1,
            preventScrollOnTouch: "auto",
            freezable: !0,
            onInit: !1,
            useLocalStorage: !0
          }, options || {});
          var doc = document, win = window, KEYS_ENTER = 13, KEYS_SPACE = 32, KEYS_PAGEUP = 33, KEYS_PAGEDOWN = 34, KEYS_END = 35, KEYS_HOME = 36, KEYS_LEFT = 37, KEYS_UP = 38, KEYS_RIGHT = 39, KEYS_DOWN = 40, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
          if (localStorageAccess) {
            var browserInfo = navigator.userAgent, uid = new Date;
            try {
              (tnsStorage = win.localStorage) ? (tnsStorage.setItem(uid, uid), localStorageAccess = tnsStorage.getItem(uid) == uid, 
              tnsStorage.removeItem(uid)) : localStorageAccess = !1, localStorageAccess || (tnsStorage = {});
            } catch (e) {
              localStorageAccess = !1;
            }
            localStorageAccess && (tnsStorage.tnsApp && tnsStorage.tnsApp !== browserInfo && [ "tC", "tPL", "tMQ", "tTf", "t3D", "tTDu", "tTDe", "tADu", "tADe", "tTE", "tAE" ].forEach((function(item) {
              tnsStorage.removeItem(item);
            })), localStorage.tnsApp = browserInfo);
          }
          var CALC = tnsStorage.tC ? checkStorageValue(tnsStorage.tC) : setLocalStorage(tnsStorage, "tC", function() {
            var doc = document, body = getBody(), docOverflow = setFakeBody(body), div = doc.createElement("div"), result = !1;
            body.appendChild(div);
            try {
              for (var val, str = "(10px * 10)", vals = [ "calc" + str, "-moz-calc" + str, "-webkit-calc" + str ], i = 0; i < 3; i++) if (val = vals[i], 
              div.style.width = val, 100 === div.offsetWidth) {
                result = val.replace(str, "");
                break;
              }
            } catch (e) {}
            return body.fake ? resetFakeBody(body, docOverflow) : div.remove(), result;
          }(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage.tPL ? checkStorageValue(tnsStorage.tPL) : setLocalStorage(tnsStorage, "tPL", function() {
            var supported, doc = document, body = getBody(), docOverflow = setFakeBody(body), wrapper = doc.createElement("div"), outer = doc.createElement("div"), str = "";
            wrapper.className = "tns-t-subp2", outer.className = "tns-t-ct";
            for (var i = 0; i < 70; i++) str += "<div></div>";
            return outer.innerHTML = str, wrapper.appendChild(outer), body.appendChild(wrapper), 
            supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[67].getBoundingClientRect().left) < 2, 
            body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove(), supported;
          }(), localStorageAccess), CSSMQ = tnsStorage.tMQ ? checkStorageValue(tnsStorage.tMQ) : setLocalStorage(tnsStorage, "tMQ", function() {
            var position, doc = document, body = getBody(), docOverflow = setFakeBody(body), div = doc.createElement("div"), style = doc.createElement("style"), rule = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}";
            return style.type = "text/css", div.className = "tns-mq-test", body.appendChild(style), 
            body.appendChild(div), style.styleSheet ? style.styleSheet.cssText = rule : style.appendChild(doc.createTextNode(rule)), 
            position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle.position, 
            body.fake ? resetFakeBody(body, docOverflow) : div.remove(), "absolute" === position;
          }(), localStorageAccess), TRANSFORM = tnsStorage.tTf ? checkStorageValue(tnsStorage.tTf) : setLocalStorage(tnsStorage, "tTf", whichProperty("transform"), localStorageAccess), HAS3DTRANSFORMS = tnsStorage.t3D ? checkStorageValue(tnsStorage.t3D) : setLocalStorage(tnsStorage, "t3D", function(tf) {
            if (!tf) return !1;
            if (!window.getComputedStyle) return !1;
            var has3d, doc = document, body = getBody(), docOverflow = setFakeBody(body), el = doc.createElement("p"), cssTF = tf.length > 9 ? "-" + tf.slice(0, -9).toLowerCase() + "-" : "";
            return cssTF += "transform", body.insertBefore(el, null), el.style[tf] = "translate3d(1px,1px,1px)", 
            has3d = window.getComputedStyle(el).getPropertyValue(cssTF), body.fake ? resetFakeBody(body, docOverflow) : el.remove(), 
            void 0 !== has3d && has3d.length > 0 && "none" !== has3d;
          }(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage.tTDu ? checkStorageValue(tnsStorage.tTDu) : setLocalStorage(tnsStorage, "tTDu", whichProperty("transitionDuration"), localStorageAccess), TRANSITIONDELAY = tnsStorage.tTDe ? checkStorageValue(tnsStorage.tTDe) : setLocalStorage(tnsStorage, "tTDe", whichProperty("transitionDelay"), localStorageAccess), ANIMATIONDURATION = tnsStorage.tADu ? checkStorageValue(tnsStorage.tADu) : setLocalStorage(tnsStorage, "tADu", whichProperty("animationDuration"), localStorageAccess), ANIMATIONDELAY = tnsStorage.tADe ? checkStorageValue(tnsStorage.tADe) : setLocalStorage(tnsStorage, "tADe", whichProperty("animationDelay"), localStorageAccess), TRANSITIONEND = tnsStorage.tTE ? checkStorageValue(tnsStorage.tTE) : setLocalStorage(tnsStorage, "tTE", getEndProperty(TRANSITIONDURATION, "Transition"), localStorageAccess), ANIMATIONEND = tnsStorage.tAE ? checkStorageValue(tnsStorage.tAE) : setLocalStorage(tnsStorage, "tAE", getEndProperty(ANIMATIONDURATION, "Animation"), localStorageAccess), supportConsoleWarn = win.console && "function" == typeof win.console.warn, tnsList = [ "container", "controlsContainer", "prevButton", "nextButton", "navContainer", "autoplayButton" ], optionsElements = {};
          if (tnsList.forEach((function(item) {
            if ("string" == typeof options[item]) {
              var str = options[item], el = doc.querySelector(str);
              if (optionsElements[item] = str, !el || !el.nodeName) return void (supportConsoleWarn && console.warn("Can't find", options[item]));
              options[item] = el;
            }
          })), !(options.container.children.length < 1)) {
            var responsive = options.responsive, nested = options.nested, carousel = "carousel" === options.mode;
            if (responsive) {
              0 in responsive && (options = extend(options, responsive[0]), delete responsive[0]);
              var responsiveTem = {};
              for (var key in responsive) {
                var val = responsive[key];
                val = "number" == typeof val ? {
                  items: val
                } : val, responsiveTem[key] = val;
              }
              responsive = responsiveTem, responsiveTem = null;
            }
            if (carousel || function updateOptions(obj) {
              for (var key in obj) carousel || ("slideBy" === key && (obj[key] = "page"), "edgePadding" === key && (obj[key] = !1), 
              "autoHeight" === key && (obj[key] = !1)), "responsive" === key && updateOptions(obj[key]);
            }(options), !carousel) {
              options.axis = "horizontal", options.slideBy = "page", options.edgePadding = !1;
              var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
            }
            var breakpointZone, horizontal = "horizontal" === options.axis, outerWrapper = doc.createElement("div"), innerWrapper = doc.createElement("div"), container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, windowWidth = getWindowWidth(), isOn = !1;
            responsive && setBreakpointZone();
            var slidePositions, imgsComplete, id, itemsMax, result, media, style, autoWidth = options.autoWidth, fixedWidth = getOption("fixedWidth"), edgePadding = getOption("edgePadding"), gutter = getOption("gutter"), viewport = getViewportWidth(), center = getOption("center"), items = autoWidth ? 1 : Math.floor(getOption("items")), slideBy = getOption("slideBy"), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption("arrowKeys"), speed = getOption("speed"), rewind = options.rewind, loop = !rewind && options.loop, autoHeight = getOption("autoHeight"), controls = getOption("controls"), controlsText = getOption("controlsText"), nav = getOption("nav"), touch = getOption("touch"), mouseDrag = getOption("mouseDrag"), autoplay = getOption("autoplay"), autoplayTimeout = getOption("autoplayTimeout"), autoplayText = getOption("autoplayText"), autoplayHoverPause = getOption("autoplayHoverPause"), autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), sheet = (style = document.createElement("style"), 
            media && style.setAttribute("media", media), document.querySelector("head").appendChild(style), 
            style.sheet ? style.sheet : style.styleSheet), lazyload = options.lazyload, slideItemsOut = (options.lazyloadSelector, 
            []), cloneCount = loop ? (itemsMax = function() {
              if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1;
              var str = fixedWidth ? "fixedWidth" : "items", arr = [];
              if ((fixedWidth || options[str] < slideCount) && arr.push(options[str]), responsive) for (var bp in responsive) {
                var tem = responsive[bp][str];
                tem && (fixedWidth || tem < slideCount) && arr.push(tem);
              }
              return arr.length || arr.push(0), Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
            }(), result = carousel ? Math.ceil((5 * itemsMax - slideCount) / 2) : 4 * itemsMax - slideCount, 
            result = Math.max(itemsMax, result), hasOption("edgePadding") ? result + 1 : result) : 0, slideCountNew = carousel ? slideCount + 2 * cloneCount : slideCount + cloneCount, hasRightDeadZone = !(!fixedWidth && !autoWidth || loop), rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop, transformAttr = horizontal ? "left" : "top", transformPrefix = "", transformPostfix = "", getIndexMax = fixedWidth ? function() {
              return Math.ceil(-rightBoundary / (fixedWidth + gutter));
            } : autoWidth ? function() {
              for (var i = slideCountNew; i--; ) if (slidePositions[i] > -rightBoundary) return i;
            } : function() {
              return center && carousel && !loop ? slideCount - 1 : loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
            }, index = getStartIndex(getOption("startIndex")), indexCached = index, indexMin = (getCurrentSlide(), 
            0), indexMax = autoWidth ? null : getIndexMax(), preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = !swipeAngle || "?", running = !1, onInit = options.onInit, events = new Events, newContainerClasses = " tns-slider tns-" + options.mode, slideId = container.id || (id = window.tnsId, 
            window.tnsId = id ? id + 1 : 1, "tns" + window.tnsId), disable = getOption("disable"), disabled = !1, freezable = options.freezable, freeze = !(!freezable || autoWidth) && getFreeze(), frozen = !1, controlsEvents = {
              click: onControlsClick,
              keydown: function(e) {
                switch ((e = getEvent(e)).keyCode) {
                 case KEYS_LEFT:
                 case KEYS_UP:
                 case KEYS_PAGEUP:
                  prevButton.disabled || onControlsClick(e, -1);
                  break;

                 case KEYS_RIGHT:
                 case KEYS_DOWN:
                 case KEYS_PAGEDOWN:
                  nextButton.disabled || onControlsClick(e, 1);
                  break;

                 case KEYS_HOME:
                  goTo("first", e);
                  break;

                 case KEYS_END:
                  goTo("last", e);
                }
              }
            }, navEvents = {
              click: function(e) {
                if (running) {
                  if (preventActionWhenRunning) return;
                  onTransitionEnd();
                }
                var navIndex, target = (e = getEvent(e)).target || e.srcElement;
                for (;target !== navContainer && !hasAttr(target, "data-nav"); ) target = target.parentNode;
                hasAttr(target, "data-nav") && (goTo(navIndex = navClicked = [].indexOf.call(navItems, target), e), 
                navCurrentIndex === navIndex && (animating && stopAutoplay(), navClicked = -1));
              },
              keydown: function(e) {
                var curElement = doc.activeElement;
                if (!hasAttr(curElement, "data-nav")) return;
                var code = (e = getEvent(e)).keyCode, navIndex = [].indexOf.call(navItems, curElement), len = visibleNavIndexes.length, current = visibleNavIndexes.indexOf(navIndex);
                options.navContainer && (len = slideCount, current = navIndex);
                function getNavIndex(num) {
                  return options.navContainer ? num : visibleNavIndexes[num];
                }
                switch (code) {
                 case KEYS_LEFT:
                 case KEYS_PAGEUP:
                  current > 0 && setFocus(navItems[getNavIndex(current - 1)]);
                  break;

                 case KEYS_UP:
                 case KEYS_HOME:
                  current > 0 && setFocus(navItems[getNavIndex(0)]);
                  break;

                 case KEYS_RIGHT:
                 case KEYS_PAGEDOWN:
                  current < len - 1 && setFocus(navItems[getNavIndex(current + 1)]);
                  break;

                 case KEYS_DOWN:
                 case KEYS_END:
                  current < len - 1 && setFocus(navItems[getNavIndex(len - 1)]);
                  break;

                 case KEYS_ENTER:
                 case KEYS_SPACE:
                  navClicked = navIndex, goTo(navIndex, e);
                }
              }
            }, hoverEvents = {
              mouseover: function() {
                animating && (stopAutoplayTimer(), autoplayHoverPaused = !0);
              },
              mouseout: function() {
                autoplayHoverPaused && (setAutoplayTimer(), autoplayHoverPaused = !1);
              }
            }, visibilityEvent = {
              visibilitychange: function() {
                doc.hidden ? animating && (stopAutoplayTimer(), autoplayVisibilityPaused = !0) : autoplayVisibilityPaused && (setAutoplayTimer(), 
                autoplayVisibilityPaused = !1);
              }
            }, docmentKeydownEvent = {
              keydown: function(e) {
                switch ((e = getEvent(e)).keyCode) {
                 case KEYS_LEFT:
                  onControlsClick(e, -1);
                  break;

                 case KEYS_RIGHT:
                  onControlsClick(e, 1);
                }
              }
            }, touchEvents = {
              touchstart: onPanStart,
              touchmove: onPanMove,
              touchend: onPanEnd,
              touchcancel: onPanEnd
            }, dragEvents = {
              mousedown: onPanStart,
              mousemove: onPanMove,
              mouseup: onPanEnd,
              mouseleave: onPanEnd
            }, hasControls = hasOption("controls"), hasNav = hasOption("nav"), navAsThumbnails = !!autoWidth || options.navAsThumbnails, hasAutoplay = hasOption("autoplay"), hasTouch = hasOption("touch"), hasMouseDrag = hasOption("mouseDrag"), slideActiveClass = "tns-slide-active", imgCompleteClass = "tns-complete", imgEvents = {
              load: function(e) {
                imgLoaded(getTarget(e));
              },
              error: function(e) {
                imgFailed(getTarget(e));
              }
            }, preventScroll = "force" === options.preventScrollOnTouch;
            if (hasControls) var prevIsButton, nextIsButton, controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : "", prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : "", nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : "";
            if (hasNav) var navItems, navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : "", visibleNavIndexes = getVisibleNavIndex(), visibleNavIndexesCached = [], navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = "tns-nav-active", navStr = "Carousel Page ", navStrCurrent = " (Current Slide)";
            if (hasAutoplay) var autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, autoplayDirection = "forward" === options.autoplayDirection ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : "", autoplayHtmlStrings = [ "<span class='tns-visually-hidden'>", " animation</span>" ];
            if (hasTouch || hasMouseDrag) var translateInit, rafIndex, initPosition = {}, lastPosition = {}, panStart = !1, getDist = horizontal ? function(a, b) {
              return a.x - b.x;
            } : function(a, b) {
              return a.y - b.y;
            };
            autoWidth || resetVariblesWhenDisable(disable || freeze), TRANSFORM && (transformAttr = TRANSFORM, 
            transformPrefix = "translate", HAS3DTRANSFORMS ? (transformPrefix += horizontal ? "3d(" : "3d(0px, ", 
            transformPostfix = horizontal ? ", 0px, 0px)" : ", 0px)") : (transformPrefix += horizontal ? "X(" : "Y(", 
            transformPostfix = ")")), function() {
              responsive && setBreakpointZone();
              !function() {
                var classOuter = "tns-outer", classInner = "tns-inner";
                hasOption("gutter");
                outerWrapper.className = classOuter, innerWrapper.className = classInner, outerWrapper.id = slideId + "-ow", 
                innerWrapper.id = slideId + "-iw", autoHeight && (innerWrapper.className += " tns-ah");
                "" === container.id && (container.id = slideId);
                newContainerClasses += PERCENTAGELAYOUT || autoWidth ? " tns-subpixel" : " tns-no-subpixel", 
                newContainerClasses += CALC ? " tns-calc" : " tns-no-calc", autoWidth && (newContainerClasses += " tns-autowidth");
                if (newContainerClasses += " tns-" + options.axis, container.className += newContainerClasses, 
                carousel) {
                  var middleWrapper = doc.createElement("div");
                  middleWrapper.className = "tns-ovh", outerWrapper.appendChild(middleWrapper), middleWrapper.appendChild(innerWrapper);
                } else outerWrapper.appendChild(innerWrapper);
                containerParent.insertBefore(outerWrapper, container), innerWrapper.appendChild(container);
              }();
              for (var x = 0; x < slideCount; x++) {
                var item = slideItems[x];
                item.id || (item.id = slideId + "-item" + x), addClass(item, "tns-item"), !carousel && animateNormal && addClass(item, animateNormal), 
                setAttrs(item, {
                  "aria-hidden": "true",
                  tabindex: "-1"
                });
              }
              if (cloneCount) {
                for (var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment(), j = cloneCount; j--; ) {
                  var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(!0);
                  if (removeAttrs(cloneFirst, "id"), fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild), 
                  carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(!0);
                    removeAttrs(cloneLast, "id"), fragmentBefore.appendChild(cloneLast);
                  }
                }
                container.insertBefore(fragmentBefore, container.firstChild), container.appendChild(fragmentAfter), 
                slideItems = container.children;
              }
              (function() {
                for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
                  var item = slideItems[i];
                  setAttrs(item, {
                    "aria-hidden": "false"
                  }), removeAttrs(item, [ "tabindex" ]), addClass(item, slideActiveClass), carousel || (item.style.left = 100 * (i - index) / items + "%", 
                  addClass(item, animateIn), removeClass(item, animateNormal));
                }
                horizontal && (PERCENTAGELAYOUT || autoWidth ? (addCSSRule(sheet, "#" + slideId + " > .tns-item", "font-size:" + win.getComputedStyle(slideItems[0]).fontSize + ";", getCssRulesLength(sheet)), 
                addCSSRule(sheet, "#" + slideId, "font-size:0;", getCssRulesLength(sheet))) : carousel && forEachNodeList(slideItems, (function(slide, i) {
                  slide.style.marginLeft = function(i) {
                    return CALC ? CALC + "(" + 100 * i + "% / " + slideCountNew + ")" : 100 * i / slideCountNew + "%";
                  }(i);
                })));
                if (CSSMQ) {
                  var str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
                  addCSSRule(sheet, "#" + slideId + "-iw", str, getCssRulesLength(sheet)), carousel && (str = horizontal && !autoWidth ? "width:" + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ";" : "", 
                  TRANSITIONDURATION && (str += getTrsnsitionDurationStyle(speed)), addCSSRule(sheet, "#" + slideId, str, getCssRulesLength(sheet))), 
                  str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : "", 
                  options.gutter && (str += getSlideGutterStyle(options.gutter)), carousel || (TRANSITIONDURATION && (str += getTrsnsitionDurationStyle(speed)), 
                  ANIMATIONDURATION && (str += getAnimationDurationStyle(speed))), str && addCSSRule(sheet, "#" + slideId + " > .tns-item", str, getCssRulesLength(sheet));
                } else {
                  innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight), 
                  carousel && horizontal && !autoWidth && (container.style.width = getContainerWidth(fixedWidth, gutter, items));
                  str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : "";
                  gutter && (str += getSlideGutterStyle(gutter)), str && addCSSRule(sheet, "#" + slideId + " > .tns-item", str, getCssRulesLength(sheet));
                }
                if (responsive && CSSMQ) for (var bp in responsive) {
                  bp = parseInt(bp);
                  var opts = responsive[bp], innerWrapperStr = (str = "", ""), containerStr = "", slideStr = "", itemsBP = autoWidth ? null : getOption("items", bp), fixedWidthBP = getOption("fixedWidth", bp), speedBP = getOption("speed", bp), edgePaddingBP = getOption("edgePadding", bp), autoHeightBP = getOption("autoHeight", bp), gutterBP = getOption("gutter", bp);
                  ("edgePadding" in opts || "gutter" in opts) && (innerWrapperStr = "#" + slideId + "-iw{" + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + "}"), 
                  carousel && horizontal && !autoWidth && ("fixedWidth" in opts || "items" in opts || fixedWidth && "gutter" in opts) && (containerStr = "width:" + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ";"), 
                  TRANSITIONDURATION && "speed" in opts && (containerStr += getTrsnsitionDurationStyle(speedBP)), 
                  containerStr && (containerStr = "#" + slideId + "{" + containerStr + "}"), ("fixedWidth" in opts || fixedWidth && "gutter" in opts || !carousel && "items" in opts) && (slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP)), 
                  "gutter" in opts && (slideStr += getSlideGutterStyle(gutterBP)), !carousel && "speed" in opts && (TRANSITIONDURATION && (slideStr += getTrsnsitionDurationStyle(speedBP)), 
                  ANIMATIONDURATION && (slideStr += getAnimationDurationStyle(speedBP))), slideStr && (slideStr = "#" + slideId + " > .tns-item{" + slideStr + "}"), 
                  (str = innerWrapperStr + containerStr + slideStr) && sheet.insertRule("@media (min-width: " + bp / 16 + "em) {" + str + "}", sheet.cssRules.length);
                }
              })(), initSliderTransform();
            }();
            var updateIndex = loop ? carousel ? function() {
              var leftEdge = indexMin, rightEdge = indexMax;
              leftEdge += slideBy, rightEdge -= slideBy, edgePadding ? (leftEdge += 1, rightEdge -= 1) : fixedWidth && (viewport + gutter) % (fixedWidth + gutter) && (rightEdge -= 1), 
              cloneCount && (index > rightEdge ? index -= slideCount : index < leftEdge && (index += slideCount));
            } : function() {
              if (index > indexMax) for (;index >= indexMin + slideCount; ) index -= slideCount; else if (index < indexMin) for (;index <= indexMax - slideCount; ) index += slideCount;
            } : function() {
              index = Math.max(indexMin, Math.min(indexMax, index));
            }, transformCore = carousel ? function() {
              var element, attr, prefix, postfix, to, duration, callback, tick, unit, from, positionTick;
              resetDuration(container, ""), TRANSITIONDURATION || !speed ? (doContainerTransform(), 
              speed && isVisible(container) || onTransitionEnd()) : (element = container, attr = transformAttr, 
              prefix = transformPrefix, postfix = transformPostfix, to = getContainerTransformValue(), 
              duration = speed, callback = onTransitionEnd, tick = Math.min(duration, 10), unit = to.indexOf("%") >= 0 ? "%" : "px", 
              to = to.replace(unit, ""), from = Number(element.style[attr].replace(prefix, "").replace(postfix, "").replace(unit, "")), 
              positionTick = (to - from) / duration * tick, setTimeout((function moveElement() {
                duration -= tick, from += positionTick, element.style[attr] = prefix + from + unit + postfix, 
                duration > 0 ? setTimeout(moveElement, tick) : callback();
              }), tick)), horizontal || updateContentWrapperHeight();
            } : function() {
              slideItemsOut = [];
              var eve = {};
              eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd, removeEvents(slideItems[indexCached], eve), 
              addEvents(slideItems[index], eve), animateSlide(indexCached, animateIn, animateOut, !0), 
              animateSlide(index, animateNormal, animateIn), TRANSITIONEND && ANIMATIONEND && speed && isVisible(container) || onTransitionEnd();
            };
            return {
              version: "2.8.8",
              getInfo: info,
              events: events,
              goTo: goTo,
              play: function() {
                autoplay && !animating && (startAutoplay(), autoplayUserPaused = !1);
              },
              pause: function() {
                animating && (stopAutoplay(), autoplayUserPaused = !0);
              },
              isOn: isOn,
              updateSliderHeight: updateInnerWrapperHeight,
              refresh: initSliderTransform,
              destroy: function() {
                if (sheet.disabled = !0, sheet.ownerNode && sheet.ownerNode.remove(), removeEvents(win, {
                  resize: onResize
                }), arrowKeys && removeEvents(doc, docmentKeydownEvent), controlsContainer && removeEvents(controlsContainer, controlsEvents), 
                navContainer && removeEvents(navContainer, navEvents), removeEvents(container, hoverEvents), 
                removeEvents(container, visibilityEvent), autoplayButton && removeEvents(autoplayButton, {
                  click: toggleAutoplay
                }), autoplay && clearInterval(autoplayTimer), carousel && TRANSITIONEND) {
                  var eve = {};
                  eve[TRANSITIONEND] = onTransitionEnd, removeEvents(container, eve);
                }
                touch && removeEvents(container, touchEvents), mouseDrag && removeEvents(container, dragEvents);
                var htmlList = [ containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML ];
                for (var a in tnsList.forEach((function(item, i) {
                  var el = "container" === item ? outerWrapper : options[item];
                  if ("object" == typeof el) {
                    var prevEl = !!el.previousElementSibling && el.previousElementSibling, parentEl = el.parentNode;
                    el.outerHTML = htmlList[i], options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
                  }
                })), tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = visibleNavIndexes = visibleNavIndexesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = panStart = rafIndex = getDist = touch = mouseDrag = null, 
                this) "rebuild" !== a && (this[a] = null);
                isOn = !1;
              },
              rebuild: function() {
                return tns(extend(options, optionsElements));
              }
            };
          }
          function resetVariblesWhenDisable(condition) {
            condition && (controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = !1);
          }
          function getCurrentSlide() {
            for (var tem = carousel ? index - cloneCount : index; tem < 0; ) tem += slideCount;
            return tem % slideCount + 1;
          }
          function getStartIndex(ind) {
            return ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0, 
            carousel ? ind + cloneCount : ind;
          }
          function getAbsIndex(i) {
            for (null == i && (i = index), carousel && (i -= cloneCount); i < 0; ) i += slideCount;
            return Math.floor(i % slideCount);
          }
          function getCurrentNavIndex() {
            var result, absIndex = getAbsIndex();
            return navAsThumbnails ? absIndex : (visibleNavIndexes.forEach((function(item, i) {
              item <= absIndex && (result = item);
            })), !loop && carousel && index === indexMax && (result = visibleNavIndexes[visibleNavIndexes.length - 1]), 
            result);
          }
          function getWindowWidth() {
            return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
          }
          function getClientWidth(el) {
            var rect, width, div = doc.createElement("div");
            return el.appendChild(div), width = (rect = div.getBoundingClientRect()).right - rect.left, 
            div.remove(), width || getClientWidth(el.parentNode);
          }
          function getViewportWidth() {
            var gap = edgePadding ? 2 * edgePadding - gutter : 0;
            return getClientWidth(containerParent) - gap;
          }
          function hasOption(item) {
            if (options[item]) return !0;
            if (responsive) for (var bp in responsive) if (responsive[bp][item]) return !0;
            return !1;
          }
          function getOption(item, ww) {
            if (null == ww && (ww = windowWidth), "items" === item && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
            var result = options[item];
            if (responsive) for (var bp in responsive) ww >= parseInt(bp) && item in responsive[bp] && (result = responsive[bp][item]);
            return "slideBy" === item && "page" === result && (result = getOption("items")), 
            carousel || "slideBy" !== item && "items" !== item || (result = Math.floor(result)), 
            result;
          }
          function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
            var str = "";
            if (void 0 !== edgePaddingTem) {
              var gap = edgePaddingTem;
              gutterTem && (gap -= gutterTem), str = horizontal ? "margin: 0 " + gap + "px 0 " + edgePaddingTem + "px;" : "margin: " + edgePaddingTem + "px 0 " + gap + "px 0;";
            } else if (gutterTem && !fixedWidthTem) {
              var gutterTemUnit = "-" + gutterTem + "px";
              str = "margin: 0 " + (horizontal ? gutterTemUnit + " 0 0" : "0 " + gutterTemUnit + " 0") + ";";
            }
            return autoHeightBP && TRANSITIONDURATION && speedTem && (str += getTrsnsitionDurationStyle(speedTem)), 
            str;
          }
          function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
            return fixedWidthTem ? (fixedWidthTem + gutterTem) * slideCountNew + "px" : CALC ? CALC + "(" + 100 * slideCountNew + "% / " + itemsTem + ")" : 100 * slideCountNew / itemsTem + "%";
          }
          function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
            var width;
            if (fixedWidthTem) width = fixedWidthTem + gutterTem + "px"; else {
              carousel || (itemsTem = Math.floor(itemsTem));
              var dividend = carousel ? slideCountNew : itemsTem;
              width = CALC ? CALC + "(100% / " + dividend + ")" : 100 / dividend + "%";
            }
            return width = "width:" + width, "inner" !== nested ? width + ";" : width + " !important;";
          }
          function getSlideGutterStyle(gutterTem) {
            var str = "";
            !1 !== gutterTem && (str = (horizontal ? "padding-" : "margin-") + (horizontal ? "right" : "bottom") + ": " + gutterTem + "px;");
            return str;
          }
          function getCSSPrefix(name, num) {
            var prefix = name.substring(0, name.length - num).toLowerCase();
            return prefix && (prefix = "-" + prefix + "-"), prefix;
          }
          function getTrsnsitionDurationStyle(speed) {
            return getCSSPrefix(TRANSITIONDURATION, 18) + "transition-duration:" + speed / 1e3 + "s;";
          }
          function getAnimationDurationStyle(speed) {
            return getCSSPrefix(ANIMATIONDURATION, 17) + "animation-duration:" + speed / 1e3 + "s;";
          }
          function initSliderTransform() {
            if (hasOption("autoHeight") || autoWidth || !horizontal) {
              var imgs = container.querySelectorAll("img");
              forEachNodeList(imgs, (function(img) {
                var src = img.src;
                src.indexOf("data:image") < 0 ? (addEvents(img, imgEvents), img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==", 
                img.src = src, addClass(img, "loading"), imgCachedCheck(img)) : lazyload || imgLoaded(img);
              })), raf((function() {
                imgsLoadedCheck(arrayFromNodeList(imgs), (function() {
                  imgsComplete = !0;
                }));
              })), !autoWidth && horizontal && (imgs = getImageArray(index, items)), lazyload ? initSliderTransformStyleCheck() : raf((function() {
                imgsLoadedCheck(arrayFromNodeList(imgs), initSliderTransformStyleCheck);
              }));
            } else carousel && doContainerTransformSilent(), initTools(), initEvents();
          }
          function initSliderTransformStyleCheck() {
            if (autoWidth) {
              var num = loop ? index : slideCount - 1;
              !function stylesApplicationCheck() {
                slideItems[num - 1].getBoundingClientRect().right.toFixed(2) === slideItems[num].getBoundingClientRect().left.toFixed(2) ? initSliderTransformCore() : setTimeout((function() {
                  stylesApplicationCheck();
                }), 16);
              }();
            } else initSliderTransformCore();
          }
          function initSliderTransformCore() {
            horizontal && !autoWidth || (getSlidePositions(), autoWidth ? (rightBoundary = getRightBoundary(), 
            freezable && (freeze = getFreeze()), indexMax = getIndexMax(), resetVariblesWhenDisable(disable || freeze)) : updateContentWrapperHeight()), 
            carousel && doContainerTransformSilent(), initTools(), initEvents();
          }
          function initTools() {
            if (hasAutoplay) {
              var txt = autoplay ? "stop" : "start";
              autoplayButton ? setAttrs(autoplayButton, {
                "data-action": txt
              }) : options.autoplayButtonOutput && (outerWrapper.insertAdjacentHTML("top" !== options.autoplayPosition ? "beforeend" : "afterbegin", '<button data-action="' + txt + '" type="button">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + "</button>"), 
              autoplayButton = outerWrapper.querySelector("[data-action]")), autoplayButton && addEvents(autoplayButton, {
                click: toggleAutoplay
              }), autoplay && (startAutoplay(), autoplayHoverPause && addEvents(container, hoverEvents), 
              autoplayResetOnVisibility && addEvents(container, visibilityEvent));
            }
            if (hasNav) {
              var initIndex = carousel ? cloneCount : 0;
              if (navContainer) setAttrs(navContainer, {
                "aria-label": "Carousel Pagination"
              }), forEachNodeList(navItems = navContainer.children, (function(item, i) {
                setAttrs(item, {
                  "data-nav": i,
                  tabindex: "-1",
                  "aria-controls": slideItems[initIndex + i].id,
                  "aria-label": navStr + (i + 1)
                });
              })); else {
                for (var navHtml = "", hiddenStr = navAsThumbnails ? "" : 'style="display:none"', i = 0; i < slideCount; i++) navHtml += '<button data-nav="' + i + '" tabindex="-1" aria-controls="' + slideItems[initIndex + i].id + '" ' + hiddenStr + ' type="button" aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + "</div>", 
                outerWrapper.insertAdjacentHTML("top" !== options.navPosition ? "beforeend" : "afterbegin", navHtml), 
                navContainer = outerWrapper.querySelector(".tns-nav"), navItems = navContainer.children;
              }
              if (updateNavVisibility(), TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = "transition: all " + speed / 1e3 + "s";
                prefix && (str = "-" + prefix + "-" + str), addCSSRule(sheet, "[aria-controls^=" + slideId + "-item]", str, getCssRulesLength(sheet));
              }
              setAttrs(navItems[navCurrentIndex], {
                tabindex: "0",
                "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
              }), addClass(navItems[navCurrentIndex], navActiveClass), addEvents(navContainer, navEvents);
            }
            hasControls && (controlsContainer || prevButton && nextButton || (outerWrapper.insertAdjacentHTML("top" !== options.controlsPosition ? "beforeend" : "afterbegin", '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button data-controls="prev" tabindex="-1" aria-controls="' + slideId + '" type="button">' + controlsText[0] + '</button><button data-controls="next" tabindex="-1" aria-controls="' + slideId + '" type="button">' + controlsText[1] + "</button></div>"), 
            controlsContainer = outerWrapper.querySelector(".tns-controls")), prevButton && nextButton || (prevButton = controlsContainer.children[0], 
            nextButton = controlsContainer.children[1]), options.controlsContainer && setAttrs(controlsContainer, {
              "aria-label": "Carousel Navigation",
              tabindex: "0"
            }), (options.controlsContainer || options.prevButton && options.nextButton) && setAttrs([ prevButton, nextButton ], {
              "aria-controls": slideId,
              tabindex: "-1"
            }), (options.controlsContainer || options.prevButton && options.nextButton) && (setAttrs(prevButton, {
              "data-controls": "prev"
            }), setAttrs(nextButton, {
              "data-controls": "next"
            })), prevIsButton = isButton(prevButton), nextIsButton = isButton(nextButton), updateControlsStatus(), 
            controlsContainer ? addEvents(controlsContainer, controlsEvents) : (addEvents(prevButton, controlsEvents), 
            addEvents(nextButton, controlsEvents))), disableUI();
          }
          function initEvents() {
            if (carousel && TRANSITIONEND) {
              var eve = {};
              eve[TRANSITIONEND] = onTransitionEnd, addEvents(container, eve);
            }
            touch && addEvents(container, touchEvents), mouseDrag && addEvents(container, dragEvents), 
            arrowKeys && addEvents(doc, docmentKeydownEvent), "inner" === nested ? events.on("outerResized", (function() {
              resizeTasks(), events.emit("innerLoaded", info());
            })) : (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) && addEvents(win, {
              resize: onResize
            }), autoHeight && ("outer" === nested ? events.on("innerLoaded", doAutoHeight) : disable || doAutoHeight()), 
            doLazyLoad(), disable ? disableSlider() : freeze && freezeSlider(), events.on("indexChanged", additionalUpdates), 
            "inner" === nested && events.emit("innerLoaded", info()), "function" == typeof onInit && onInit(info()), 
            isOn = !0;
          }
          function onResize(e) {
            raf((function() {
              resizeTasks(getEvent(e));
            }));
          }
          function resizeTasks(e) {
            if (isOn) {
              "outer" === nested && events.emit("outerResized", info(e)), windowWidth = getWindowWidth();
              var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = !1;
              responsive && (setBreakpointZone(), (bpChanged = breakpointZoneTem !== breakpointZone) && events.emit("newBreakpointStart", info(e)));
              var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
              if (bpChanged) {
                var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
                if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
              }
              if (arrowKeys = getOption("arrowKeys"), controls = getOption("controls"), nav = getOption("nav"), 
              touch = getOption("touch"), center = getOption("center"), mouseDrag = getOption("mouseDrag"), 
              autoplay = getOption("autoplay"), autoplayHoverPause = getOption("autoplayHoverPause"), 
              autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), bpChanged && (disable = getOption("disable"), 
              fixedWidth = getOption("fixedWidth"), speed = getOption("speed"), autoHeight = getOption("autoHeight"), 
              controlsText = getOption("controlsText"), autoplayText = getOption("autoplayText"), 
              autoplayTimeout = getOption("autoplayTimeout"), CSSMQ || (edgePadding = getOption("edgePadding"), 
              gutter = getOption("gutter"))), resetVariblesWhenDisable(disable), viewport = getViewportWidth(), 
              horizontal && !autoWidth || disable || (getSlidePositions(), horizontal || (updateContentWrapperHeight(), 
              needContainerTransform = !0)), (fixedWidth || autoWidth) && (rightBoundary = getRightBoundary(), 
              indexMax = getIndexMax()), (bpChanged || fixedWidth) && (items = getOption("items"), 
              slideBy = getOption("slideBy"), (itemsChanged = items !== itemsTem) && (fixedWidth || autoWidth || (indexMax = getIndexMax()), 
              updateIndex())), bpChanged && disable !== disableTem && (disable ? disableSlider() : function() {
                if (!disabled) return;
                if (sheet.disabled = !1, container.className += newContainerClasses, doContainerTransformSilent(), 
                loop) for (var j = cloneCount; j--; ) carousel && showElement(slideItems[j]), showElement(slideItems[slideCountNew - j - 1]);
                if (!carousel) for (var i = index, l = index + slideCount; i < l; i++) {
                  var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
                  item.style.left = 100 * (i - index) / items + "%", addClass(item, classN);
                }
                enableUI(), disabled = !1;
              }()), freezable && (bpChanged || fixedWidth || autoWidth) && (freeze = getFreeze()) !== freezeTem && (freeze ? (doContainerTransform(getContainerTransformValue(getStartIndex(0))), 
              freezeSlider()) : (!function() {
                if (!frozen) return;
                edgePadding && CSSMQ && (innerWrapper.style.margin = "");
                if (cloneCount) for (var str = "tns-transparent", i = cloneCount; i--; ) carousel && removeClass(slideItems[i], str), 
                removeClass(slideItems[slideCountNew - i - 1], str);
                enableUI(), frozen = !1;
              }(), needContainerTransform = !0)), resetVariblesWhenDisable(disable || freeze), 
              autoplay || (autoplayHoverPause = autoplayResetOnVisibility = !1), arrowKeys !== arrowKeysTem && (arrowKeys ? addEvents(doc, docmentKeydownEvent) : removeEvents(doc, docmentKeydownEvent)), 
              controls !== controlsTem && (controls ? controlsContainer ? showElement(controlsContainer) : (prevButton && showElement(prevButton), 
              nextButton && showElement(nextButton)) : controlsContainer ? hideElement(controlsContainer) : (prevButton && hideElement(prevButton), 
              nextButton && hideElement(nextButton))), nav !== navTem && (nav ? (showElement(navContainer), 
              updateNavVisibility()) : hideElement(navContainer)), touch !== touchTem && (touch ? addEvents(container, touchEvents) : removeEvents(container, touchEvents)), 
              mouseDrag !== mouseDragTem && (mouseDrag ? addEvents(container, dragEvents) : removeEvents(container, dragEvents)), 
              autoplay !== autoplayTem && (autoplay ? (autoplayButton && showElement(autoplayButton), 
              animating || autoplayUserPaused || startAutoplay()) : (autoplayButton && hideElement(autoplayButton), 
              animating && stopAutoplay())), autoplayHoverPause !== autoplayHoverPauseTem && (autoplayHoverPause ? addEvents(container, hoverEvents) : removeEvents(container, hoverEvents)), 
              autoplayResetOnVisibility !== autoplayResetOnVisibilityTem && (autoplayResetOnVisibility ? addEvents(doc, visibilityEvent) : removeEvents(doc, visibilityEvent)), 
              bpChanged) {
                if (fixedWidth === fixedWidthTem && center === centerTem || (needContainerTransform = !0), 
                autoHeight !== autoHeightTem && (autoHeight || (innerWrapper.style.height = "")), 
                controls && controlsText !== controlsTextTem && (prevButton.innerHTML = controlsText[0], 
                nextButton.innerHTML = controlsText[1]), autoplayButton && autoplayText !== autoplayTextTem) {
                  var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                  html.substring(len) === autoplayTextTem[i] && (autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i]);
                }
              } else center && (fixedWidth || autoWidth) && (needContainerTransform = !0);
              if ((indChanged = index !== indexTem) && (events.emit("indexChanged", info()), needContainerTransform = !0), 
              itemsChanged && (visibleNavIndexes = getVisibleNavIndex(), updateNavVisibility(), 
              indChanged || additionalUpdates(), carousel || function() {
                for (var l = index + Math.min(slideCount, items), i = slideCountNew; i--; ) {
                  var item = slideItems[i];
                  i >= index && i < l ? (addClass(item, "tns-moving"), item.style.left = 100 * (i - index) / items + "%", 
                  addClass(item, animateIn), removeClass(item, animateNormal)) : item.style.left && (item.style.left = "", 
                  addClass(item, animateNormal), removeClass(item, animateIn)), removeClass(item, animateOut);
                }
                setTimeout((function() {
                  forEachNodeList(slideItems, (function(el) {
                    removeClass(el, "tns-moving");
                  }));
                }), 300);
              }()), !disable && !freeze) {
                if (bpChanged && !CSSMQ && (edgePadding === edgePaddingTem && gutter === gutterTem || (innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight)), 
                horizontal)) {
                  carousel && (container.style.width = getContainerWidth(fixedWidth, gutter, items));
                  var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                  !function(sheet, index) {
                    "deleteRule" in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
                  }(sheet, getCssRulesLength(sheet) - 1), addCSSRule(sheet, "#" + slideId + " > .tns-item", str, getCssRulesLength(sheet));
                }
                autoHeight && doAutoHeight(), needContainerTransform && (doContainerTransformSilent(), 
                indexCached = index);
              }
              bpChanged && events.emit("newBreakpointEnd", info(e));
            }
          }
          function getFreeze() {
            return fixedWidth || autoWidth ? (fixedWidth ? (fixedWidth + gutter) * slideCount : loop ? slidePositions[slideCount] : getSliderWidth()) <= viewport + 2 * edgePadding : slideCount <= items;
          }
          function setBreakpointZone() {
            for (var bp in breakpointZone = 0, responsive) bp = parseInt(bp), windowWidth >= bp && (breakpointZone = bp);
          }
          function disableUI() {
            !autoplay && autoplayButton && hideElement(autoplayButton), !nav && navContainer && hideElement(navContainer), 
            controls || (controlsContainer ? hideElement(controlsContainer) : (prevButton && hideElement(prevButton), 
            nextButton && hideElement(nextButton)));
          }
          function enableUI() {
            autoplay && autoplayButton && showElement(autoplayButton), nav && navContainer && showElement(navContainer), 
            controls && (controlsContainer ? showElement(controlsContainer) : (prevButton && showElement(prevButton), 
            nextButton && showElement(nextButton)));
          }
          function freezeSlider() {
            if (!frozen) {
              if (edgePadding && (innerWrapper.style.margin = "0px"), cloneCount) for (var str = "tns-transparent", i = cloneCount; i--; ) carousel && addClass(slideItems[i], str), 
              addClass(slideItems[slideCountNew - i - 1], str);
              disableUI(), frozen = !0;
            }
          }
          function disableSlider() {
            if (!disabled) {
              if (sheet.disabled = !0, container.className = container.className.replace(newContainerClasses.substring(1), ""), 
              removeAttrs(container, [ "style" ]), loop) for (var j = cloneCount; j--; ) carousel && hideElement(slideItems[j]), 
              hideElement(slideItems[slideCountNew - j - 1]);
              if (horizontal && carousel || removeAttrs(innerWrapper, [ "style" ]), !carousel) for (var i = index, l = index + slideCount; i < l; i++) {
                var item = slideItems[i];
                removeAttrs(item, [ "style" ]), removeClass(item, animateIn), removeClass(item, animateNormal);
              }
              disableUI(), disabled = !0;
            }
          }
          function getVisibleSlideRange() {
            var end, rangestart, rangeend, start = index;
            if (center || edgePadding ? (autoWidth || fixedWidth) && (rangestart = center || edgePadding ? -(getContainerTransformValue().replace(/%|px/, "") + edgePadding) : slidePositions[index], 
            rangeend = rangestart + viewport) : autoWidth && (rangestart = slidePositions[index]), 
            autoWidth) center || edgePadding || (rangeend = rangestart + viewport), slidePositions.forEach((function(point, i) {
              (center || edgePadding) && point <= rangestart && (start = i), point < rangeend && (end = i);
            })); else if (center || edgePadding) if (fixedWidth) {
              var cell = fixedWidth + gutter;
              start = Math.floor(Math.max(rangestart, 0) / cell), end = Math.ceil(rangeend / cell);
            } else center && (start -= (items - 1) / 2), edgePadding && (start -= edgePadding * items / viewport), 
            end = start + items, edgePadding && (end += (2 * edgePadding - gutter) * items / viewport), 
            start = Math.floor(Math.max(start, 0)), end = Math.floor(end); else end = start + items;
            return [ start, end ];
          }
          function doLazyLoad() {
            lazyload && !disable && getImageArray.apply(null, getVisibleSlideRange()).forEach((function(img) {
              if (!hasClass(img, imgCompleteClass)) {
                var eve = {};
                eve[TRANSITIONEND] = function(e) {
                  e.stopPropagation();
                }, addEvents(img, eve), addEvents(img, imgEvents);
                var srcset = getAttr(img, "data-srcset");
                srcset && (img.srcset = srcset), img.src = getAttr(img, "data-src"), addClass(img, "loading"), 
                imgCachedCheck(img);
              }
            }));
          }
          function imgLoaded(img) {
            addClass(img, "loaded"), imgCompleted(img);
          }
          function imgFailed(img) {
            addClass(img, "failed"), imgCompleted(img);
          }
          function imgCompleted(img) {
            addClass(img, "tns-complete"), removeClass(img, "loading"), removeEvents(img, imgEvents);
          }
          function imgCachedCheck(img) {
            img.complete && (0 !== img.naturalWidth ? imgLoaded(img) : imgFailed(img));
          }
          function getImageArray(start, end) {
            var imgs = [];
            for (end = Math.min(end, slideCountNew - 1); start <= end; ) forEachNodeList(slideItems[start].querySelectorAll("img"), (function(img) {
              imgs.push(img);
            })), start++;
            return imgs;
          }
          function doAutoHeight() {
            var imgs = getImageArray.apply(null, getVisibleSlideRange());
            raf((function() {
              imgsLoadedCheck(imgs, updateInnerWrapperHeight);
            }));
          }
          function imgsLoadedCheck(imgs, cb) {
            return imgsComplete ? cb() : (imgs.forEach((function(img, index) {
              hasClass(img, imgCompleteClass) && imgs.splice(index, 1);
            })), imgs.length ? void raf((function() {
              imgsLoadedCheck(imgs, cb);
            })) : cb());
          }
          function additionalUpdates() {
            doLazyLoad(), function() {
              for (var l = index + Math.min(slideCount, items), i = slideCountNew; i--; ) {
                var item = slideItems[i];
                i >= index && i < l ? hasAttr(item, "tabindex") && (setAttrs(item, {
                  "aria-hidden": "false"
                }), removeAttrs(item, [ "tabindex" ]), addClass(item, slideActiveClass)) : (hasAttr(item, "tabindex") || setAttrs(item, {
                  "aria-hidden": "true",
                  tabindex: "-1"
                }), hasClass(item, slideActiveClass) && removeClass(item, slideActiveClass));
              }
            }(), updateControlsStatus(), function() {
              if (nav && (navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex(), 
              navClicked = -1, navCurrentIndex !== navCurrentIndexCached)) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                setAttrs(navPrev, {
                  tabindex: "-1",
                  "aria-label": navStr + (navCurrentIndexCached + 1)
                }), setAttrs(navCurrent, {
                  tabindex: "0",
                  "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
                }), removeClass(navPrev, navActiveClass), addClass(navCurrent, navActiveClass), 
                navCurrentIndexCached = navCurrentIndex;
              }
            }();
          }
          function getMaxSlideHeight(slideStart, slideRange) {
            for (var heights = [], i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) heights.push(slideItems[i].offsetHeight);
            return Math.max.apply(null, heights);
          }
          function updateInnerWrapperHeight() {
            var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount);
            innerWrapper.style.height !== maxHeight && (innerWrapper.style.height = maxHeight + "px");
          }
          function getSlidePositions() {
            slidePositions = [ 0 ];
            for (var position, attr = horizontal ? "left" : "top", first = slideItems[0].getBoundingClientRect()[attr], i = 1; i < slideCountNew; i++) position = slideItems[i].getBoundingClientRect()[attr], 
            slidePositions.push(position - first);
          }
          function getLowerCaseNodeName(el) {
            return el.nodeName.toLowerCase();
          }
          function isButton(el) {
            return "button" === getLowerCaseNodeName(el);
          }
          function isAriaDisabled(el) {
            return "true" === el.getAttribute("aria-disabled");
          }
          function disEnableElement(isButton, el, val) {
            isButton ? el.disabled = val : el.setAttribute("aria-disabled", val.toString());
          }
          function updateControlsStatus() {
            if (controls && !rewind && !loop) {
              var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin, disableNext = !rewind && index >= indexMax;
              disablePrev && !prevDisabled && disEnableElement(prevIsButton, prevButton, !0), 
              !disablePrev && prevDisabled && disEnableElement(prevIsButton, prevButton, !1), 
              disableNext && !nextDisabled && disEnableElement(nextIsButton, nextButton, !0), 
              !disableNext && nextDisabled && disEnableElement(nextIsButton, nextButton, !1);
            }
          }
          function resetDuration(el, str) {
            TRANSITIONDURATION && (el.style[TRANSITIONDURATION] = str);
          }
          function getSliderWidth() {
            return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew - 1] + slideItems[slideCountNew - 1].getBoundingClientRect().width;
          }
          function getRightBoundary() {
            var result = viewport + gutter - getSliderWidth();
            return center && (result -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slideItems[slideCountNew - 1].clientWidth - gutter)) / 2), 
            result > 0 && (result = 0), result;
          }
          function getContainerTransformValue(num) {
            var val;
            (null == num && (num = index), horizontal && !autoWidth) ? fixedWidth ? (val = -(fixedWidth + gutter) * num, 
            center && (val += (viewport - fixedWidth) / 2)) : (center && (num -= (items - 1) / 2), 
            val = 100 * -num / (TRANSFORM ? slideCountNew : items)) : (val = -slidePositions[num], 
            center && horizontal && (val += (viewport - (slideItems[num].offsetWidth - gutter)) / 2));
            return hasRightDeadZone && (val = Math.max(val, rightBoundary)), val += !horizontal || autoWidth || fixedWidth ? "px" : "%";
          }
          function doContainerTransformSilent(val) {
            resetDuration(container, "0s"), doContainerTransform(val);
          }
          function doContainerTransform(val) {
            null == val && (val = getContainerTransformValue()), container.style[transformAttr] = transformPrefix + val + transformPostfix;
          }
          function animateSlide(number, classOut, classIn, isOut) {
            var l = number + items;
            loop || (l = Math.min(l, slideCountNew));
            for (var i = number; i < l; i++) {
              var item = slideItems[i];
              isOut || (item.style.left = 100 * (i - index) / items + "%"), animateDelay && TRANSITIONDELAY && (item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1e3 + "s"), 
              removeClass(item, classOut), addClass(item, classIn), isOut && slideItemsOut.push(item);
            }
          }
          function render(e, sliderMoved) {
            updateIndexBeforeTransform && updateIndex(), (index !== indexCached || sliderMoved) && (events.emit("indexChanged", info()), 
            events.emit("transitionStart", info()), autoHeight && doAutoHeight(), animating && e && [ "click", "keydown" ].indexOf(e.type) >= 0 && stopAutoplay(), 
            running = !0, transformCore());
          }
          function strTrans(str) {
            return str.toLowerCase().replace(/-/g, "");
          }
          function onTransitionEnd(event) {
            if (carousel || running) {
              if (events.emit("transitionEnd", info(event)), !carousel && slideItemsOut.length > 0) for (var i = 0; i < slideItemsOut.length; i++) {
                var item = slideItemsOut[i];
                item.style.left = "", ANIMATIONDELAY && TRANSITIONDELAY && (item.style[ANIMATIONDELAY] = "", 
                item.style[TRANSITIONDELAY] = ""), removeClass(item, animateOut), addClass(item, animateNormal);
              }
              if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                  var indexTem = index;
                  updateIndex(), index !== indexTem && (events.emit("indexChanged", info()), doContainerTransformSilent());
                }
                "inner" === nested && events.emit("innerLoaded", info()), running = !1, indexCached = index;
              }
            }
          }
          function goTo(targetIndex, e) {
            if (!freeze) if ("prev" === targetIndex) onControlsClick(e, -1); else if ("next" === targetIndex) onControlsClick(e, 1); else {
              if (running) {
                if (preventActionWhenRunning) return;
                onTransitionEnd();
              }
              var absIndex = getAbsIndex(), indexGap = 0;
              if ("first" === targetIndex ? indexGap = -absIndex : "last" === targetIndex ? indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex : ("number" != typeof targetIndex && (targetIndex = parseInt(targetIndex)), 
              isNaN(targetIndex) || (e || (targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex))), 
              indexGap = targetIndex - absIndex)), !carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : 2 * slideCount * factor * -1;
              }
              index += indexGap, carousel && loop && (index < indexMin && (index += slideCount), 
              index > indexMax && (index -= slideCount)), getAbsIndex(index) !== getAbsIndex(indexCached) && render(e);
            }
          }
          function onControlsClick(e, dir) {
            if (running) {
              if (preventActionWhenRunning) return;
              onTransitionEnd();
            }
            var passEventObject;
            if (!dir) {
              for (var target = (e = getEvent(e)).target || e.srcElement; target !== controlsContainer && [ prevButton, nextButton ].indexOf(target) < 0; ) target = target.parentNode;
              var targetIn = [ prevButton, nextButton ].indexOf(target);
              targetIn >= 0 && (passEventObject = !0, dir = 0 === targetIn ? -1 : 1);
            }
            if (rewind) {
              if (index === indexMin && -1 === dir) return void goTo("last", e);
              if (index === indexMax && 1 === dir) return void goTo("first", e);
            }
            dir && (index += slideBy * dir, autoWidth && (index = Math.floor(index)), render(passEventObject || e && "keydown" === e.type ? e : null));
          }
          function setAutoplayTimer() {
            autoplayTimer = setInterval((function() {
              onControlsClick(null, autoplayDirection);
            }), autoplayTimeout), animating = !0;
          }
          function stopAutoplayTimer() {
            clearInterval(autoplayTimer), animating = !1;
          }
          function updateAutoplayButton(action, txt) {
            setAttrs(autoplayButton, {
              "data-action": action
            }), autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
          }
          function startAutoplay() {
            setAutoplayTimer(), autoplayButton && updateAutoplayButton("stop", autoplayText[1]);
          }
          function stopAutoplay() {
            stopAutoplayTimer(), autoplayButton && updateAutoplayButton("start", autoplayText[0]);
          }
          function toggleAutoplay() {
            animating ? (stopAutoplay(), autoplayUserPaused = !0) : (startAutoplay(), autoplayUserPaused = !1);
          }
          function setFocus(focus) {
            focus.focus();
          }
          function getEvent(e) {
            return isTouchEvent(e = e || win.event) ? e.changedTouches[0] : e;
          }
          function getTarget(e) {
            return e.target || win.event.srcElement;
          }
          function isTouchEvent(e) {
            return e.type.indexOf("touch") >= 0;
          }
          function preventDefaultBehavior(e) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
          }
          function getMoveDirectionExpected() {
            return y = lastPosition.y - initPosition.y, x = lastPosition.x - initPosition.x, 
            angle = Math.atan2(y, x) * (180 / Math.PI), range = swipeAngle, direction = !1, 
            (gap = Math.abs(90 - Math.abs(angle))) >= 90 - range ? direction = "horizontal" : gap <= range && (direction = "vertical"), 
            direction === options.axis;
            var angle, range, direction, gap, y, x;
          }
          function onPanStart(e) {
            if (running) {
              if (preventActionWhenRunning) return;
              onTransitionEnd();
            }
            autoplay && animating && stopAutoplayTimer(), panStart = !0, rafIndex && (caf(rafIndex), 
            rafIndex = null);
            var $ = getEvent(e);
            events.emit(isTouchEvent(e) ? "touchStart" : "dragStart", info(e)), !isTouchEvent(e) && [ "img", "a" ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0 && preventDefaultBehavior(e), 
            lastPosition.x = initPosition.x = parseInt($.clientX), lastPosition.y = initPosition.y = parseInt($.clientY), 
            carousel && (translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, "").replace(transformPostfix, "")), 
            resetDuration(container, "0s"));
          }
          function onPanMove(e) {
            if (panStart) {
              var $ = getEvent(e);
              lastPosition.x = parseInt($.clientX), lastPosition.y = parseInt($.clientY), carousel ? rafIndex || (rafIndex = raf((function() {
                panUpdate(e);
              }))) : ("?" === moveDirectionExpected && (moveDirectionExpected = getMoveDirectionExpected()), 
              moveDirectionExpected && (preventScroll = !0)), preventScroll && e.preventDefault();
            }
          }
          function panUpdate(e) {
            if (moveDirectionExpected) {
              if (caf(rafIndex), panStart && (rafIndex = raf((function() {
                panUpdate(e);
              }))), "?" === moveDirectionExpected && (moveDirectionExpected = getMoveDirectionExpected()), 
              moveDirectionExpected) {
                !preventScroll && isTouchEvent(e) && (preventScroll = !0);
                try {
                  e.type && events.emit(isTouchEvent(e) ? "touchMove" : "dragMove", info(e));
                } catch (err) {}
                var x = translateInit, dist = getDist(lastPosition, initPosition);
                if (!horizontal || fixedWidth || autoWidth) x += dist, x += "px"; else x += TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : 100 * dist / (viewport + gutter), 
                x += "%";
                container.style[transformAttr] = transformPrefix + x + transformPostfix;
              }
            } else panStart = !1;
          }
          function onPanEnd(e) {
            if (panStart) {
              rafIndex && (caf(rafIndex), rafIndex = null), carousel && resetDuration(container, ""), 
              panStart = !1;
              var $ = getEvent(e);
              lastPosition.x = parseInt($.clientX), lastPosition.y = parseInt($.clientY);
              var dist = getDist(lastPosition, initPosition);
              if (Math.abs(dist)) {
                if (!isTouchEvent(e)) {
                  var target = getTarget(e);
                  addEvents(target, {
                    click: function preventClick(e) {
                      preventDefaultBehavior(e), removeEvents(target, {
                        click: preventClick
                      });
                    }
                  });
                }
                carousel ? rafIndex = raf((function() {
                  if (horizontal && !autoWidth) {
                    var indexMoved = -dist * items / (viewport + gutter);
                    indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved), index += indexMoved;
                  } else {
                    var moved = -(translateInit + dist);
                    if (moved <= 0) index = indexMin; else if (moved >= slidePositions[slidePositions.length - 1]) index = indexMax; else for (var i = 0; i < slideCountNew && moved >= slidePositions[i]; ) index = i, 
                    moved > slidePositions[i] && dist < 0 && (index += 1), i++;
                  }
                  render(e, dist), events.emit(isTouchEvent(e) ? "touchEnd" : "dragEnd", info(e));
                })) : moveDirectionExpected && onControlsClick(e, dist > 0 ? -1 : 1);
              }
            }
            "auto" === options.preventScrollOnTouch && (preventScroll = !1), swipeAngle && (moveDirectionExpected = "?"), 
            autoplay && !animating && setAutoplayTimer();
          }
          function updateContentWrapperHeight() {
            innerWrapper.style.height = slidePositions[index + items] - slidePositions[index] + "px";
          }
          function getVisibleNavIndex() {
            for (var arr = [], i = 0, max = Math.ceil(slideCount / items); i < max; ) arr.push(i * items), 
            i++;
            return arr;
          }
          function updateNavVisibility() {
            nav && !navAsThumbnails && visibleNavIndexes !== visibleNavIndexesCached && (forEachNodeList(navItems, (function(el, i) {
              visibleNavIndexes.indexOf(i) < 0 ? hideElement(el) : showElement(el);
            })), visibleNavIndexesCached = visibleNavIndexes);
          }
          function info(e) {
            return {
              container: container,
              slideItems: slideItems,
              navContainer: navContainer,
              navItems: navItems,
              controlsContainer: controlsContainer,
              hasControls: hasControls,
              prevButton: prevButton,
              nextButton: nextButton,
              items: items,
              slideBy: slideBy,
              cloneCount: cloneCount,
              slideCount: slideCount,
              slideCountNew: slideCountNew,
              index: index,
              indexCached: indexCached,
              displayIndex: getCurrentSlide(),
              navCurrentIndex: navCurrentIndex,
              navCurrentIndexCached: navCurrentIndexCached,
              visibleNavIndexes: visibleNavIndexes,
              visibleNavIndexesCached: visibleNavIndexesCached,
              sheet: sheet,
              isOn: isOn,
              event: e || {}
            };
          }
          supportConsoleWarn && console.warn("No slides found in", options.container);
        };
        return tns;
      }();
      function scroll2(element, to, duration) {
        if (!(duration <= 0)) {
          var perTick = (to - element.scrollTop) / duration * 10;
          setTimeout((function() {
            if (element == document.body) {
              if (document.documentElement.scrollTop = document.body.scrollTop = element.scrollTop + perTick, 
              document.documentElement.scrollTop == to || document.body.scrollTop == to) return;
            } else if (element.scrollTop = element.scrollTop + perTick, element.scrollTop == to) return;
            scroll2(element, to, duration - 10);
          }), 10);
        }
      }
      function scrollLinks() {
        var links = document.querySelectorAll('a[href^="#"]'), header = document.querySelector("header");
        [].forEach.call(links, (function(link) {
          link.addEventListener("click", (function(event) {
            if ("#" != link.getAttribute("href")) {
              event.preventDefault();
              var target = document.querySelector(link.getAttribute("href"));
              target && scroll2(document.body, target.getBoundingClientRect().top + window.pageYOffset - header.clientHeight, 500);
            }
          }));
        }));
      }
      !function() {
        function run() {
          var elems = document.querySelectorAll("[data-mh]"), done = [];
          elems && [].forEach.call(elems, (function(elem) {
            var mh = elem.dataset.mh;
            -1 == done.indexOf(mh) && (!function(selector) {
              var sortableList = document.querySelectorAll(selector);
              if (sortableList) {
                for (var heights = [], i = 0, x = sortableList.length; i < x; i++) sortableList[i].style && sortableList[i].style.height && (sortableList[i].style.height = ""), 
                heights.push(sortableList[i].clientHeight);
                for (var max = Math.max.apply(Math, heights), j = 0, y = sortableList.length; j < y; j++) sortableList[j].style.height = max + "px";
              }
            }('[data-mh="' + mh + '"]'), done.push(mh));
          }));
        }
        window.addEventListener("resize", run), window.addEventListener("load", run);
      }(), scrollLinks();
      var docCookies = {
        getItem: function(sKey) {
          return sKey && decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
        },
        setItem: function(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
          if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) return !1;
          var sExpires = "";
          if (vEnd) switch (vEnd.constructor) {
           case Number:
            sExpires = vEnd === 1 / 0 ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
            break;

           case String:
            sExpires = "; expires=" + vEnd;
            break;

           case Date:
            sExpires = "; expires=" + vEnd.toUTCString();
          }
          return document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : ""), 
          !0;
        },
        removeItem: function(sKey, sPath, sDomain) {
          return !!this.hasItem(sKey) && (document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : ""), 
          !0);
        },
        hasItem: function(sKey) {
          return !(!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) && new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
        },
        keys: function() {
          for (var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
          return aKeys;
        },
        clear: function(sPath, sDomain) {
          for (var aKeys = this.keys(), nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) this.removeItem(aKeys[nIdx], sPath, sDomain);
        }
      };
      function Countdown(args) {
        this.dispatch = !1, this.delivery = !1, this.time_to_cutoff = !1, this.countdown_days = !1, 
        this.countdown_hours = !1, this.countdown_minutes = !1, this.cutoff_hour = args.cutoff_hour, 
        this.cutoff_minute = args.cutoff_minute, this.lead_time_days = args.lead_time_days, 
        this.dispatch_days = args.dispatch_days, this.delivery_days = args.delivery_days, 
        this.exclusion_dispatch = args.exclusion_dispatch, this.exclusion_delivery = args.exclusion_delivery, 
        this.actual_time = args.actual_time || new Date, this.actual_time_tick = function() {
          this.actual_time = new Date(this.actual_time.getTime() + 1e3);
        }, this.get_next_available_dispatch = function() {
          this.dispatch = !1;
          var this_day = new Date(this.actual_time.getTime());
          for (this_day.setHours(this.cutoff_hour), this_day.setMinutes(this.cutoff_minute), 
          this_day.setSeconds(0), this_day.setMilliseconds(0); 0 == this.dispatch; ) 1 == this.get_is_dispatch_day(this_day.getDay()) && this.get_time_to_cutoff(this_day) > 0 && 0 == this.get_is_exclusion_dispatch_date(this_day) && (this.dispatch = this_day), 
          this_day = new Date(this_day.getTime() + 864e5);
          return this.dispatch;
        }, this.get_next_available_delivery = function() {
          this.delivery = !1;
          var this_day = new Date(this.dispatch.getTime() + 864e5);
          this_day.setHours(0), this_day.setMinutes(0), this_day.setSeconds(0), this_day.setMilliseconds(1);
          for (var lead_time_count = 0; 0 == this.delivery; ) 1 == this.get_is_delivery_day(this_day.getDay()) && 0 == this.get_is_exclusion_delivery_date(this_day) && ++lead_time_count == this.lead_time_days && (this.delivery = this_day), 
          this_day = new Date(this_day.getTime() + 864e5);
          return this.delivery;
        }, this.get_time_to_cutoff = function(cutoff_datetime) {
          var today = new Date;
          return cutoff_datetime.getTime() - today.getTime();
        }, this.is_valid = function() {
          return this.get_time_to_cutoff(this.dispatch) > 0;
        }, this.get_is_dispatch_day = function(day_index) {
          if (this.dispatch_days.length > 0) for (var i = 0; i < this.dispatch_days.length; i++) if (this.dispatch_days[i] == day_index) return !0;
          return !1;
        }, this.get_is_delivery_day = function(day_index) {
          if (this.delivery_days.length > 0) for (var i = 0; i < this.delivery_days.length; i++) if (this.delivery_days[i] == day_index) return !0;
          return !1;
        }, this.get_is_exclusion_dispatch_date = function(proposed_date) {
          var check_date = new Date(proposed_date.getTime());
          if (check_date.setHours(0), check_date.setMinutes(0), check_date.setSeconds(0), 
          check_date.setMilliseconds(0), this.exclusion_dispatch.length > 0) for (var i = 0; i < this.exclusion_dispatch.length; i++) if (this.exclusion_dispatch[i].getTime() == check_date.getTime()) return !0;
          return !1;
        }, this.get_is_exclusion_delivery_date = function(proposed_date) {
          var check_date = new Date(proposed_date.getTime());
          if (check_date.setHours(0), check_date.setMinutes(0), check_date.setSeconds(0), 
          check_date.setMilliseconds(0), this.exclusion_delivery.length > 0) for (var i = 0; i < this.exclusion_delivery.length; i++) if (this.exclusion_delivery[i].getTime() == check_date.getTime()) return !0;
          return !1;
        }, this.update = function() {
          this.actual_time_tick(), this.time_left_to_order = this.get_time_to_cutoff(this.dispatch), 
          this.countdown_days = Math.floor(this.time_left_to_order / 864e5), this.countdown_hours = Math.floor(this.time_left_to_order % 864e5 / 36e5), 
          this.countdown_minutes = Math.floor(this.time_left_to_order % 36e5 / 6e4), this.countdown_seconds = Math.floor(this.time_left_to_order % 6e4 / 1e3);
        }, this.init = function() {
          this.dispatch = this.get_next_available_dispatch(), this.delivery = this.get_next_available_delivery(), 
          this.time_left_to_order = this.get_time_to_cutoff(this.dispatch), this.countdown_days = Math.floor(this.time_left_to_order / 864e5), 
          this.countdown_hours = Math.floor(this.time_left_to_order % 864e5 / 36e5), this.countdown_minutes = Math.floor(this.time_left_to_order % 36e5 / 6e4), 
          this.countdown_seconds = Math.floor(this.time_left_to_order % 6e4 / 1e3);
        };
      }
      void 0 !== module.exports && (module.exports = docCookies), (forms = document.querySelectorAll(".mailing-list")) && [].forEach.call(forms, (function(form) {
        form.addEventListener("submit", (function(event) {
          event.preventDefault();
          for (var data = "", button = this.querySelector('input[type="submit"]'), url = this.action.replace("/post?", "/post-json?"), inputs = this.querySelectorAll('input:not([type="submit"])'), i = 0; i < inputs.length; i++) data += "&" + inputs[i].name + "=" + encodeURIComponent(inputs[i].value);
          button.value = "Please wait...";
          var script = document.createElement("script");
          script.src = url + data, document.body.appendChild(script);
          window.callback = function(data) {
            delete window.callback, document.body.removeChild(script), "success" == data.result ? button.value = "Success!" : button.value = "Error";
          };
        }));
      }));
      var html = document.querySelector("html"), main = (body = document.querySelector("body"), 
      header = document.querySelector("header"), document.querySelector("aside"), document.querySelector("main")), menuOpens = document.querySelectorAll(".menu-open"), menuCloses = document.querySelectorAll(".menu-close"), stylesheet = document.querySelector("#MainCSS"), critical = document.querySelector("#CriticalCSS"), opacity = setInterval((function() {
        0 == body.style.opacity && (body.style.opacity = 1, clearInterval(opacity));
      }), 500), closeMenu = function() {
        html.classList.remove("menu");
      };
      stylesheet && critical && (stylesheet.hasAttribute("data-href"), stylesheet.addEventListener("load", (function() {
        critical.parentNode.removeChild(critical);
      }))), [].forEach.call(menuOpens, (function(menuOpen) {
        menuOpen.addEventListener("click", (function(event) {
          event.preventDefault(), html.classList.add("menu");
        }));
      })), [].forEach.call(menuCloses, (function(menuClose) {
        menuClose.addEventListener("click", (function(event) {
          event.preventDefault(), closeMenu();
        }));
      })), document.addEventListener("keydown", (function(event) {
        "Escape" == event.key && closeMenu();
      })), header.addEventListener("mousedown", (function(event) {
        closeMenu();
      })), main.addEventListener("mousedown", (function(event) {
        closeMenu();
      }));
      var banner = document.querySelector("#Banner");
      if (banner) {
        docCookies.getItem("promoHide") || banner.classList.add("active");
        var sliderNav = document.querySelector(".slider-container .slider-nav");
        if (sliderNav) {
          var fixDots = function(reset) {
            var height = reset || !banner.classList.contains("active") ? 0 : banner.clientHeight;
            sliderNav.style.bottom = height + 20 + "px";
          };
          fixDots(), window.addEventListener("resize", fixDots(!1));
        }
        var bannerClose = banner.querySelector("span");
        bannerClose && bannerClose.addEventListener("click", (function(event) {
          if (event.preventDefault(), banner.classList.remove("active"), "function" == typeof fixDots && fixDots(!0), 
          parseInt(banner.dataset.duration) > 0) {
            var date = new Date;
            date.setDate(date.getDate() + parseInt(banner.dataset.duration)), docCookies.setItem("promoHide", !0, date);
          }
        }));
      }
      window.addEventListener("load", (function() {
        var portion = getParameterByName("portion");
        if (portion) {
          var selects = document.querySelectorAll("select.single-option-selector");
          selects && [].forEach.call(selects, (function(select) {
            for (var options = select.options, i = 0; i < options.length; i++) -1 != options[i].text.indexOf(portion) && (select.selectedIndex = i);
          }));
        }
        var discount = getParameterByName("discount");
        discount && "undefined" != typeof Storage && localStorage.setItem("discount", discount);
      })), window.addEventListener("load", (function() {
        var sliders = document.querySelectorAll(".slider-container"), placeholders = document.querySelectorAll(".slider-placeholder");
        function removeSliders(keep) {
          [].forEach.call(placeholders, (function(placeholder) {
            placeholder.parentNode.removeChild(placeholder);
          })), [].forEach.call(sliders, (function(slider) {
            slider.parentNode.parentNode.id == keep.parentNode.parentNode.id ? slider.style.display = "block" : slider.parentNode.removeChild(slider);
          }));
        }
        if (sliders.length > 1 && void 0 !== _alephbet_min_js__WEBPACK_IMPORTED_MODULE_0__.AlephBet) {
          alert("test");
          new _alephbet_min_js__WEBPACK_IMPORTED_MODULE_0__.AlephBet.Experiment({
            name: "Slider images",
            variants: {
              white: {
                activate: function() {
                  removeSliders(sliders[0]);
                }
              },
              fullbleed: {
                activate: function() {
                  removeSliders(sliders[1]);
                }
              }
            }
          });
        } else removeSliders(sliders[0]);
      }));
      var field;
      ((field = document.querySelector("#Countdown")) && window.addEventListener("load", (function() {
        var days = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday (select Saturday Delivery at checkout)" ], excludes = [ "2019-01-01", "2019-04-19", "2019-04-22", "2019-05-06", "2019-05-27", "2019-08-26", "2019-12-25", "2019-12-26", "2020-01-01", "2020-04-10", "2020-04-13", "2020-05-04", "2020-05-25", "2020-08-31", "2020-12-25", "2020-12-28" ].map((function(date) {
          var d = new Date(date);
          return 0 != d.getTimezoneOffset() && d.setHours(d.getHours() + d.getTimezoneOffset() / 60), 
          d;
        })), countdown_args = {
          cutoff_hour: 5 == (new Date).getDay() ? 12 : 14,
          cutoff_minute: 0,
          lead_time_days: 1,
          dispatch_days: [ 1, 2, 3, 4, 5 ],
          delivery_days: [ 1, 2, 3, 4, 5, 6 ],
          exclusion_dispatch: excludes,
          exclusion_delivery: excludes,
          actual_time: new Date
        }, countdown = new Countdown(countdown_args);
        countdown.init(), setInterval((function() {
          countdown.is_valid() ? countdown.update() : countdown.init();
          var text = "";
          if (countdown.delivery.getDay() == countdown_args.actual_time.getDay() + 1) if (6 == countdown.delivery.getDay()) var day = "tomorrow (select Saturday Delivery at checkout)"; else day = "tomorrow"; else day = days[countdown.delivery.getDay()];
          text += 'Order within the next <strong class="orange">', countdown.countdown_days > 1 ? text += countdown.countdown_days + " days " : countdown.countdown_days > 0 && (text += countdown.countdown_days + " day "), 
          countdown.countdown_hours > 1 ? text += countdown.countdown_hours + " hours " : countdown.countdown_hours > 0 && (text += countdown.countdown_hours + " hour "), 
          countdown.countdown_minutes > 1 ? text += countdown.countdown_minutes + " minutes " : countdown.countdown_minutes > 0 && (text += countdown.countdown_minutes + " minute "), 
          countdown.countdown_hours < 1 && (1 == countdown.countdown_seconds ? text += countdown.countdown_seconds + " second " : text += countdown.countdown_seconds + " seconds "), 
          text += '</strong> for delivery <strong class="orange">' + day + "</strong>.", field.innerHTML = text;
        }), 1e3);
      })), window.addEventListener("load", (function() {
        var sliders = document.querySelectorAll(".slider");
        [].forEach.call(sliders, (function(el) {
          var slider = tns({
            arrowKeys: !0,
            autoplay: !0,
            autoplayButtonOutput: !1,
            autoplayTimeout: 3e3,
            speed: 500,
            axis: el.dataset.axis || "horizontal",
            container: slider,
            controls: !1,
            mode: "gallery",
            nav: !0,
            navContainer: ".slider-nav"
          }), changeCallback = function(info) {
            info = slider.getInfo();
            var html = document.querySelector("html");
            info.slideItems[info.index].classList.contains("light") ? html.classList.add("light-header") : html.classList.remove("light-header"), 
            lazyLoad();
          };
          slider.events.on("transitionStart", changeCallback), changeCallback();
        }));
      })), document.querySelector("#instafeed")) && new Instafeed({
        get: "user",
        userId: 10366626641,
        clientId: "d168c9b2b60a43d68a6dd8ad4bfa8972",
        accessToken: "10366626641.1677ed0.45349071836445848f14dc46562d3c63",
        limit: 4,
        resolution: "standard_resolution",
        template: '<div><a href="{{link}}" target="_blank" class="insta-link" data-image="{{image}}"><div class="overlay"><p>{{caption}}</p></div></a></div>'
      }).run();
      var popup = document.querySelector("#popup"), popEnabled = getParameterByName("popup");
      if (popup) if (popup.dataset.always && -1 == document.referrer.indexOf("able.dog") && (popEnabled = !0), 
      popEnabled) {
        popup.classList.add("active");
        var closes = popup.querySelectorAll("a");
        [].forEach.call(closes, (function(close) {
          close.addEventListener("click", (function() {
            popup.classList.remove("active");
          }));
        }));
      } else popup.parentNode.removeChild(popup);
      var forms, shipPopup = document.querySelector("#shipping"), shipPopEnabled = getParameterByName("shipping");
      if (shipPopup) if (shipPopEnabled) {
        shipPopup.classList.add("active");
        closes = shipPopup.querySelectorAll("a");
        [].forEach.call(closes, (function(close) {
          close.addEventListener("click", (function() {
            shipPopup.classList.remove("active");
          }));
        }));
      } else shipPopup.parentNode.removeChild(shipPopup);
      function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(location.search);
        return null === results ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
      }
      if ((forms = document.querySelectorAll(".calculator form")).length) {
        var currentUrl = window.location.href.substr(window.location.href.lastIndexOf("/") + 1).split("?")[0];
        function updateCartAttributes(data) {
          var get_xhr = new XMLHttpRequest;
          get_xhr.open("GET", Fieldify.routes.root + "cart.js"), get_xhr.setRequestHeader("Content-Type", "application/json"), 
          get_xhr.onreadystatechange = function() {
            if (JSON.parse(get_xhr.response).item_count < 1) {
              var add_xhr = new XMLHttpRequest;
              add_xhr.open("POST", Fieldify.routes.root + "cart/add.js"), add_xhr.setRequestHeader("Content-Type", "application/json"), 
              add_xhr.onreadystatechange = function() {
                if (4 === add_xhr.readyState) {
                  var clear_xhr = new XMLHttpRequest;
                  clear_xhr.open("POST", Fieldify.routes.root + "cart/update.js", !0), clear_xhr.setRequestHeader("Content-Type", "application/json"), 
                  clear_xhr.send(JSON.stringify({
                    updates: {
                      27465639198784: 0
                    }
                  }));
                  var attr_xhr = new XMLHttpRequest;
                  attr_xhr.open("POST", Fieldify.routes.root + "cart/update.js"), attr_xhr.setRequestHeader("Content-Type", "application/json"), 
                  attr_xhr.send(JSON.stringify(data));
                }
              }, add_xhr.send(JSON.stringify({
                id: 27465639198784,
                quantity: 1
              }));
            } else {
              var attr_xhr = new XMLHttpRequest;
              attr_xhr.open("POST", Fieldify.routes.root + "cart/update.js"), attr_xhr.setRequestHeader("Content-Type", "application/json"), 
              attr_xhr.send(JSON.stringify(data));
            }
          }, get_xhr.send();
        }
        function titleCase(str) {
          return (str = str.replace(/-/g, " ").toLowerCase().split(" ").map((function(word) {
            return word.replace(word[0], word[0].toUpperCase());
          }))).join(" ").replace(/With/g, "with").replace(/And/g, "and");
        }
        function calculate(form, buttonOnly) {
          if (form) {
            var lifestage = form.querySelector('select[name="lifestage"]'), weight = form.querySelector('select[name="weight"]'), activity = form.querySelector('select[name="activity"]'), meals = form.querySelector('select[name="meals"]'), recipe = form.querySelector('select[name="recipe"]'), result = form.querySelector(".result"), resultTxt = "", submit = form.querySelector('input[type="submit"]');
            if ("puppy_250" == lifestage.value ? [].forEach.call(weight, (function(option) {
              parseInt(option.value) > 50 && (option.disabled = !0, option.style.display = "none", 
              weight.value == option.value && (weight.selectedIndex = 0));
            })) : [].forEach.call(weight, (function(option) {
              option.disabled = !1, option.style.display = "block";
            })), -1 != lifestage.value.indexOf("puppy") || -1 != lifestage.value.indexOf("junior")) {
              var maxMer = 250;
              activity.disabled = !0, activity.selectedIndex = 0, activity.options[0].value = parseInt(lifestage.value.split("_")[1]), 
              -1 != lifestage.value.indexOf("puppy") && (activity.options[0].innerHTML = "N/A (all puppies are active)"), 
              -1 != lifestage.value.indexOf("junior") && (activity.options[0].innerHTML = "N/A (all juniors are active)"), 
              [].forEach.call(recipe, (function(option) {
                option.disabled = !1, option.style.display = "block";
              })), [].forEach.call(recipe, (function(option) {
                (-1 != lifestage.value.indexOf("puppy") && !parseInt(option.dataset.puppy) || -1 != lifestage.value.indexOf("junior") && !parseInt(option.dataset.junior)) && (option.disabled = !0, 
                option.style.display = "none", recipe.value == option.value && (recipe.selectedIndex = 0));
              }));
            } else {
              maxMer = 190;
              activity.options[0].value = "", activity.options[0].innerHTML = "Activity level", 
              activity.disabled = !1, [].forEach.call(recipe, (function(option) {
                option.disabled = !1, option.style.display = "block";
              }));
            }
            var data = {
              attributes: {}
            }, fields = [ lifestage, activity, weight, meals, recipe ];
            if ([].forEach.call(fields, (function(field) {
              "" == field.value ? field.classList.add("required") : (data.attributes[titleCase(field.name)] = field.selectedOptions[0].text, 
              field.classList.remove("required"));
            })), "" != lifestage.value && "" != activity.value && "" != weight.value && "" != meals.value && "" != recipe.value) {
              if (submit.disabled = !1, submit.value = "Calculate", buttonOnly) return !0;
              var constant = Math.pow(parseInt(weight.value), .75), change = -1 != lifestage.value.indexOf("puppy") || -1 != lifestage.value.indexOf("junior") ? 0 : parseInt(lifestage.value), kcal = constant * Math.min(Math.max(activity.value * (1 + change / 100), 95), maxMer), lifetext = (meals.value, 
              lifestage.selectedOptions[0].text), recipeName = recipe.selectedOptions[0].text, recipeUrl = recipe.selectedOptions[0].dataset.url, sizes = [ 150, 200, 250, 300, 350, 400, 500 ], grams = kcal / recipe.value * 100, perMeal = (grams / meals.value > 1.1 * sizes[sizes.length - 1] ? grams / 2 : grams) / meals.value, portion = sizes.reduce((function(prev, curr) {
                return Math.abs(curr - perMeal) < Math.abs(prev - perMeal) ? curr : prev;
              })), portionsPerMeal = Math.round(grams / meals.value / portion), totalGrams = portionsPerMeal * portion * meals.value;
              if (perMeal < 110) var portionTitle = "Portion size?"; else portionTitle = portionsPerMeal > 1 ? portionsPerMeal + "x" + portion : String(portion);
              var portionTitleFull = portionTitle.indexOf("?") > -1 ? portionTitle : portionTitle + "g portions";
              if (resultTxt += '<p class="text-center text-xl">' + portionTitleFull + "</p><p>In order to <strong>", 
              data.attributes.Portion = portionTitleFull, lifetext.indexOf("Underweight") > -1 ? resultTxt += "gain a little weight" : lifetext.indexOf("Overweight") > -1 ? resultTxt += "lose a little weight" : lifestage.value.indexOf("puppy") > -1 || lifestage.value.indexOf("junior") > -1 ? resultTxt += "grow and develop" : resultTxt += "maintain excellent body condition", 
              resultTxt += "</strong>, your dog requires <strong>" + Math.round(kcal).toLocaleString() + "kcal</strong> each day. ", 
              resultTxt += "<strong>" + Math.round(grams).toLocaleString() + "g</strong> per day of our <strong>" + recipeName + "</strong> recipe would provide this.</p>", 
              perMeal < 110) resultTxt += "<p>Our smallest portion size is 150g and that amount of food per meal would provide your dog with too many calories. Choose a portion size that best allows you to feed approximately <strong>" + Math.round(grams) + "g per day</strong>."; else {
                resultTxt += "<p>Feed ", resultTxt += "<strong>" + portionTitle + "g</strong> portions", 
                1 == meals.value ? resultTxt += ", once a day" : 2 == meals.value ? resultTxt += ", twice a day" : 3 == meals.value && (resultTxt += ", three times a day"), 
                resultTxt += ".<br>You can move ", portionsPerMeal > 1 && (resultTxt += "one portion ");
                var accuracy = (totalGrams - grams) / totalGrams * 100;
                resultTxt += accuracy < -6 ? "up" : accuracy > 6 ? "down" : "up or down", resultTxt += portionsPerMeal > 1 ? " a size " : " a portion size ", 
                meals.value > 1 && (resultTxt += "for one or more meals "), resultTxt += "next time if needed.";
              }
              var resultUrl = "/products/";
              -1 != lifestage.value.indexOf("puppy") && (resultUrl += "puppy-"), -1 != lifestage.value.indexOf("junior") && (resultUrl += "junior-"), 
              resultUrl += recipeUrl + "?portion=" + portion + "g";
              try {
                if (currentUrl == recipeUrl || currentUrl == recipeUrl + "-working" || currentUrl == "working-" + recipeUrl || currentUrl == "working-puppy-" + recipeUrl || currentUrl == "working-junior-" + recipeUrl) {
                  resultUrl = "#product";
                  if ("URLSearchParams" in window) {
                    var searchParams = new URLSearchParams(window.location.search);
                    searchParams.set("portion", portion + "g");
                    var newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                    history.pushState(null, "", newRelativePathQuery);
                  }
                }
              } catch (e) {}
              resultTxt += '<p><a class="button" href="' + (resultUrl = (resultUrl = resultUrl.replace(/puppy-puppy-/i, "puppy-")).replace(/junior-junior-/i, "junior-")) + '">Shop now</a></p>', 
              result.innerHTML = resultTxt, window.location.href.indexOf("/products/") > -1 && scrollLinks();
              var selector = document.querySelector('select[data-option="option1"]');
              if (selector) for (var i = 0, sL = selector.length; i < sL; i++) if (-1 != selector.options[i].text.indexOf(portion + "g")) {
                selector.selectedIndex = i;
                break;
              }
              return updateCartAttributes(data), portion;
            }
            submit.disabled = !0;
          }
          return result.innerHTML = "", !1;
        }
        const recipes = {
          "beef-with-turkey": {
            kcal: 171,
            puppy: !0,
            junior: !0,
            available: !0
          },
          "chicken-and-duck": {
            kcal: 166,
            puppy: !0,
            junior: !0,
            available: !0
          },
          "chicken-with-beef": {
            kcal: 172,
            puppy: !0,
            junior: !0,
            available: !0
          },
          "chicken-with-turkey": {
            kcal: 151,
            puppy: !0,
            junior: !0,
            available: !0
          },
          "lamb-and-beef": {
            kcal: 202,
            puppy: !1,
            junior: !0,
            available: !0
          },
          "lamb-and-chicken-with-beef": {
            kcal: 192,
            puppy: !1,
            junior: !0,
            available: !0
          },
          "lamb-and-turkey-with-beef": {
            kcal: 182,
            puppy: !0,
            junior: !0,
            available: !0
          },
          turkey: {
            kcal: 160,
            puppy: !1,
            junior: !1,
            available: !0
          }
        };
        [].forEach.call(forms, (function(form) {
          window.addEventListener("load", (function() {
            var select = form.querySelector('select[name="recipe"]');
            select.options.length <= 1 && Object.keys(recipes).forEach((function(recipe) {
              var option = document.createElement("option");
              option.text = titleCase(recipe), option.value = recipes[recipe].kcal, option.dataset.url = recipe, 
              option.dataset.puppy = recipes[recipe].puppy ? 1 : 0, option.dataset.junior = recipes[recipe].junior ? 1 : 0, 
              option.dataset.available = recipes[recipe].available ? 1 : 0, recipes[recipe].available || (option.disabled = !0, 
              option.text += " [Coming soon]"), currentUrl != recipe && currentUrl != recipe + "-working" && currentUrl != "working-" + recipe || (option.selected = !0), 
              select.add(option);
            }));
          })), form.addEventListener("submit", (function(event) {
            event.preventDefault(), calculate(this);
          }));
          var selects = form.querySelectorAll("select"), result = document.querySelector(".result");
          [].forEach.call(selects, (function(select) {
            select.addEventListener("change", (function(event) {
              event.preventDefault();
              var buttonOnly = "" == result.innerText;
              calculate(form, buttonOnly);
            }));
          }));
        }));
      }
      if (void 0 === Fieldify) {
        var Fieldify = {};
        window.Fieldify = Fieldify;
      }
      Fieldify.each = function(ary, callback) {
        for (var i = 0; i < ary.length; i++) callback(ary[i], i);
      }, Fieldify.map = function(ary, callback) {
        for (var result = [], i = 0; i < ary.length; i++) result.push(callback(ary[i], i));
        return result;
      }, Fieldify.arrayIncludes = function(ary, obj) {
        for (var i = 0; i < ary.length; i++) if (ary[i] == obj) return !0;
        return !1;
      }, Fieldify.uniq = function(ary) {
        for (var result = [], i = 0; i < ary.length; i++) Fieldify.arrayIncludes(result, ary[i]) || result.push(ary[i]);
        return result;
      }, Fieldify.isDefined = function(obj) {
        return void 0 !== obj;
      }, Fieldify.getClass = function(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1);
      }, Fieldify.extend = function(subClass, baseClass) {
        function inheritance() {}
        inheritance.prototype = baseClass.prototype, subClass.prototype = new inheritance, 
        subClass.prototype.constructor = subClass, subClass.baseConstructor = baseClass, 
        subClass.superClass = baseClass.prototype;
      }, Fieldify.urlParam = function(name) {
        var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
      }, Fieldify.Product = function(json) {
        Fieldify.isDefined(json) && this.update(json);
      }, Fieldify.Product.prototype.update = function(json) {
        for (var property in json) this[property] = json[property];
      }, Fieldify.Product.prototype.optionNames = function() {
        return "Array" == Fieldify.getClass(this.options) ? this.options : [];
      }, Fieldify.Product.prototype.optionValues = function(index) {
        if (!Fieldify.isDefined(this.variants)) return null;
        var results = Fieldify.map(this.variants, (function(e) {
          var option_col = "option" + (index + 1);
          return null == e[option_col] ? null : e[option_col];
        }));
        return null == results[0] ? null : Fieldify.uniq(results);
      }, Fieldify.Product.prototype.getVariant = function(selectedValues) {
        var found = null;
        return selectedValues.length != this.options.length || Fieldify.each(this.variants, (function(variant) {
          for (var satisfied = !0, j = 0; j < selectedValues.length; j++) {
            variant["option" + (j + 1)] != selectedValues[j] && (satisfied = !1);
          }
          1 != satisfied || (found = variant);
        })), found;
      }, Fieldify.Product.prototype.getVariantById = function(id) {
        for (var i = 0; i < this.variants.length; i++) {
          var variant = this.variants[i];
          if (id == variant.id) return variant;
        }
        return null;
      }, Fieldify.money_format = "£{{amount}}", Fieldify.formatMoney = function(cents, format) {
        "string" == typeof cents && (cents = cents.replace(".", ""));
        var value = "", placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || this.money_format;
        function defaultOption(opt, def) {
          return void 0 === opt ? def : opt;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
          if (precision = defaultOption(precision, 2), thousands = defaultOption(thousands, ","), 
          decimal = defaultOption(decimal, "."), isNaN(number) || null == number) return 0;
          var parts = (number = (number / 100).toFixed(precision)).split(".");
          return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands) + (parts[1] ? decimal + parts[1] : "");
        }
        switch (formatString.match(placeholderRegex)[1]) {
         case "amount":
          value = formatWithDelimiters(cents, 2);
          break;

         case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;

         case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;

         case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
        }
        return formatString.replace(placeholderRegex, value);
      }, Fieldify.OptionSelectors = function(existingSelectorId, options) {
        return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", 
        this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, 
        this.selectors = [], this.domIdPrefix = existingSelectorId, this.product = new Fieldify.Product(options.product), 
        this.onVariantSelected = Fieldify.isDefined(options.onVariantSelected) ? options.onVariantSelected : function() {}, 
        this.replaceSelector(existingSelectorId), this.initDropdown(), options.enableHistoryState && (this.historyState = new Fieldify.OptionSelectors.HistoryState(this)), 
        !0;
      }, Fieldify.OptionSelectors.prototype.initDropdown = function() {
        var options = {
          initialLoad: !0
        };
        if (!this.selectVariantFromDropdown(options)) {
          var self = this;
          setTimeout((function() {
            self.selectVariantFromParams(options) || self.fireOnChangeForFirstDropdown.call(self, options);
          }));
        }
      }, Fieldify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(options) {
        this.selectors[0].element.onchange(options);
      }, Fieldify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(options) {
        this.selectVariantFromParams(options) || this.selectVariantFromDropdown(options);
      }, Fieldify.OptionSelectors.prototype.replaceSelector = function(domId) {
        var oldSelector = document.getElementById(domId), parent = oldSelector.parentNode;
        Fieldify.each(this.buildSelectors(), (function(el) {
          parent.insertBefore(el, oldSelector);
        })), oldSelector.style.display = "none", this.variantIdField = oldSelector;
      }, Fieldify.OptionSelectors.prototype.selectVariantFromDropdown = function(options) {
        var option = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if (!option) return !1;
        var variantId = option.value;
        return this.selectVariant(variantId, options);
      }, Fieldify.OptionSelectors.prototype.selectVariantFromParams = function(options) {
        var variantId = Fieldify.urlParam("variant");
        return this.selectVariant(variantId, options);
      }, Fieldify.OptionSelectors.prototype.selectVariant = function(variantId, options) {
        var variant = this.product.getVariantById(variantId);
        if (null == variant) return !1;
        for (var i = 0; i < this.selectors.length; i++) {
          var element = this.selectors[i].element, value = variant[element.getAttribute("data-option")];
          null != value && this.optionExistInSelect(element, value) && (element.value = value);
        }
        return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", options) : this.selectors[0].element.onchange(options), 
        !0;
      }, Fieldify.OptionSelectors.prototype.optionExistInSelect = function(select, value) {
        for (var i = 0; i < select.options.length; i++) if (select.options[i].value == value) return !0;
      }, Fieldify.OptionSelectors.prototype.insertSelectors = function(domId, messageElementId) {
        Fieldify.isDefined(messageElementId) && this.setMessageElement(messageElementId), 
        this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
        var parent = document.getElementById(domId);
        Fieldify.each(this.buildSelectors(), (function(el) {
          parent.appendChild(el);
        }));
      }, Fieldify.OptionSelectors.prototype.buildSelectors = function() {
        for (var i = 0; i < this.product.optionNames().length; i++) {
          var sel = new Fieldify.SingleOptionSelector(this, i, this.product.optionNames()[i], this.product.optionValues(i));
          sel.element.disabled = !1, this.selectors.push(sel);
        }
        this.selectorDivClass, this.product.optionNames();
        return Fieldify.map(this.selectors, (function(selector) {
          return selector.element;
        }));
      }, Fieldify.OptionSelectors.prototype.selectedValues = function() {
        for (var currValues = [], i = 0; i < this.selectors.length; i++) {
          var thisValue = this.selectors[i].element.value;
          currValues.push(thisValue);
        }
        return currValues;
      }, Fieldify.OptionSelectors.prototype.updateSelectors = function(index, options) {
        var currValues = this.selectedValues(), variant = this.product.getVariant(currValues);
        variant ? (this.variantIdField.disabled = !1, this.variantIdField.value = variant.id) : this.variantIdField.disabled = !0, 
        this.onVariantSelected(variant, this, options), null != this.historyState && this.historyState.onVariantChange(variant, this, options);
      }, Fieldify.OptionSelectorsFromDOM = function(existingSelectorId, options) {
        var optionNames = options.optionNames || [], priceFieldExists = options.priceFieldExists || !0, delimiter = options.delimiter || "/", productObj = this.createProductFromSelector(existingSelectorId, optionNames, priceFieldExists, delimiter);
        options.product = productObj, Fieldify.OptionSelectorsFromDOM.baseConstructor.call(this, existingSelectorId, options);
      }, Fieldify.extend(Fieldify.OptionSelectorsFromDOM, Fieldify.OptionSelectors), Fieldify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(domId, optionNames, priceFieldExists, delimiter) {
        if (!Fieldify.isDefined(priceFieldExists)) priceFieldExists = !0;
        if (!Fieldify.isDefined(delimiter)) delimiter = "/";
        var oldSelector = document.getElementById(domId), options = oldSelector.childNodes, optionCount = (oldSelector.parentNode, 
        optionNames.length), variants = [];
        Fieldify.each(options, (function(option, variantIndex) {
          if (1 == option.nodeType && "option" == option.tagName.toLowerCase()) {
            var chunks = option.innerHTML.split(new RegExp("\\s*\\" + delimiter + "\\s*"));
            0 == optionNames.length && (optionCount = chunks.length - (priceFieldExists ? 1 : 0));
            var optionOptionValues = chunks.slice(0, optionCount), message = priceFieldExists ? chunks[optionCount] : "", attributes = (option.getAttribute("value"), 
            {
              available: !option.disabled,
              id: parseFloat(option.value),
              price: message,
              option1: optionOptionValues[0],
              option2: optionOptionValues[1],
              option3: optionOptionValues[2]
            });
            variants.push(attributes);
          }
        }));
        var updateObj = {
          variants: variants
        };
        if (0 == optionNames.length) {
          updateObj.options = [];
          for (var i = 0; i < optionCount; i++) updateObj.options[i] = "option " + (i + 1);
        } else updateObj.options = optionNames;
        return updateObj;
      }, Fieldify.SingleOptionSelector = function(multiSelector, index, name, values) {
        this.multiSelector = multiSelector, this.values = values, this.index = index, this.name = name, 
        this.element = document.createElement("select"), (opt = document.createElement("option")).value = "", 
        opt.innerHTML = "Select " + name, this.element.appendChild(opt);
        for (var i = 0; i < values.length; i++) {
          var opt;
          (opt = document.createElement("option")).value = values[i], opt.innerHTML = values[i], 
          this.element.appendChild(opt);
        }
        return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (index + 1)), 
        index + 1 == 2 && (this.element.style.display = "none"), this.element.id = multiSelector.domIdPrefix + "-option-" + index, 
        this.element.onchange = function(event, options) {
          options = options || {}, multiSelector.updateSelectors(index, options);
        }, !0;
      }, Fieldify.Image = {
        preload: function(images, size) {
          for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
          }
        },
        loadImage: function(path) {
          (new Image).src = path;
        },
        switchImage: function(image, element, callback) {
          if (image && element) {
            var size = this.imageSize(element.src), imageUrl = this.getSizedImageUrl(image.src, size);
            callback ? callback(imageUrl, image, element) : element.src = imageUrl;
          }
        },
        imageSize: function(src) {
          var match = src.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
          return null != match ? match[1] : null;
        },
        getSizedImageUrl: function(src, size) {
          if (null == size) return src;
          if ("master" == size) return this.removeProtocol(src);
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (null != match) {
            var prefix = src.split(match[0]), suffix = match[0];
            return this.removeProtocol(prefix[0] + "_" + size + suffix);
          }
          return null;
        },
        removeProtocol: function(path) {
          return path.replace(/http(s)?:/, "");
        }
      }, Fieldify.OptionSelectors.HistoryState = function(optionSelector) {
        this.browserSupports() && this.register(optionSelector);
      }, Fieldify.OptionSelectors.HistoryState.prototype.register = function(optionSelector) {
        window.addEventListener("popstate", (function(event) {
          optionSelector.selectVariantFromParamsOrDropdown({
            popStateCall: !0
          });
        }));
      }, Fieldify.OptionSelectors.HistoryState.prototype.onVariantChange = function(variant, selector, data) {
        this.browserSupports() && (!variant || data.initialLoad || data.popStateCall || window.history.replaceState({}, document.title, "?variant=" + variant.id));
      }, Fieldify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
        return window.history && window.history.replaceState;
      };
    }
  }, __webpack_module_cache__ = {};
  function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
      id: moduleId,
      loaded: !1,
      exports: {}
    };
    return __webpack_modules__[moduleId](module, module.exports, __webpack_require__), 
    module.loaded = !0, module.exports;
  }
  __webpack_require__.n = function(module) {
    var getter = module && module.__esModule ? function() {
      return module.default;
    } : function() {
      return module;
    };
    return __webpack_require__.d(getter, {
      a: getter
    }), getter;
  }, __webpack_require__.d = function(exports, definition) {
    for (var key in definition) __webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key) && Object.defineProperty(exports, key, {
      enumerable: !0,
      get: definition[key]
    });
  }, __webpack_require__.g = function() {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), __webpack_require__.hmd = function(module) {
    return (module = Object.create(module)).children || (module.children = []), Object.defineProperty(module, "exports", {
      enumerable: !0,
      set: function() {
        throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + module.id);
      }
    }), module;
  }, __webpack_require__.o = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }, __webpack_require__.r = function(exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.nc = void 0, __webpack_require__(520);
  var __webpack_exports__ = __webpack_require__(88);
})();